var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.cooperate,
              expression: "!cooperate"
            }
          ]
        },
        [
          _c(
            "div",
            [
              _vm.nextstep
                ? _c(
                    "div",
                    { staticClass: "info-all" },
                    [
                      _c(
                        "el-aside",
                        {
                          staticClass: "aside-left",
                          style: { height: _vm.boxHeight },
                          attrs: { width: "3.2rem" }
                        },
                        [
                          _c("p", { staticClass: "page-total" }, [
                            _c("span", { staticClass: "tit" }, [
                              _vm._v("签署文件列表")
                            ]),
                            _c("span", [
                              _vm._v(
                                "（共" + _vm._s(_vm.fileList.length) + "个）"
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "aside-left_flex" }, [
                            _c(
                              "div",
                              {
                                staticClass: "page-con",
                                style: { height: _vm.leftCSideHeight }
                              },
                              [
                                _vm._l(_vm.fileList, function(file, i) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: i,
                                        staticClass: "list",
                                        class:
                                          _vm.checkAct === i ? "active" : "",
                                        on: {
                                          click: function($event) {
                                            return _vm.chooseFile(file, i)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "light",
                                              placement: "right-start"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [_vm._v("此文件设置有签署位置")]
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.filePage(file),
                                                  expression: "filePage(file)"
                                                }
                                              ],
                                              staticClass:
                                                "icon icon-status_sign"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.beWord(file.fileName) ||
                                                  (file.useTo &&
                                                    file.useTo === 1),
                                                expression:
                                                  "\n                        beWord(file.fileName) ||\n                        (file.useTo && file.useTo === 1)\n                      "
                                              }
                                            ],
                                            staticClass: "tpl-icon tpl-posi",
                                            staticStyle: { "z-index": "1" },
                                            on: {
                                              click: function($event) {
                                                return _vm.InOnlyOffice(file, i)
                                              }
                                            }
                                          },
                                          [_vm._v("编辑")]
                                        ),
                                        _c("div", { staticClass: "bx" }, [
                                          _c("img", {
                                            attrs: { src: _vm.fileIcon(file) }
                                          })
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "title",
                                            attrs: { title: file.fileName }
                                          },
                                          [_vm._v(_vm._s(file.fileName))]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                })
                              ],
                              2
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "transition",
                                  { attrs: { name: "el-zoom-in-top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "list-pages",
                                        style: { height: _vm.leftCSideHeight }
                                      },
                                      [
                                        _vm._l(
                                          _vm.contractInfoTemporary.items,
                                          function(i) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  key: i,
                                                  staticClass: "listDetail",
                                                  class:
                                                    _vm.currentInfo.page === i
                                                      ? "active"
                                                      : "",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getContractDetailByNum(
                                                        i
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.imgShowFn(i)
                                                    }
                                                  }),
                                                  _c("span", [
                                                    _vm._v(_vm._s(i))
                                                  ]),
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "light",
                                                        placement: "right-start"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            slot: "content"
                                                          },
                                                          slot: "content"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "此页面设置有签署位置"
                                                          )
                                                        ]
                                                      ),
                                                      _c("i", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: _vm.fixedFilePage(
                                                              i
                                                            ),
                                                            expression:
                                                              "fixedFilePage(i)"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "icon icon-status_sign"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _c("transition", { attrs: { name: "el-fade-in" } }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.drawerShow,
                              expression: "drawerShow"
                            }
                          ],
                          staticClass: "aside",
                          style: { height: _vm.boxHeight }
                        })
                      ]),
                      _c("transition", { attrs: { name: "my" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.drawerShow,
                                expression: "drawerShow"
                              }
                            ],
                            staticClass: "aside-content",
                            style: { height: _vm.boxHeight }
                          },
                          [
                            _c("div", { staticClass: "aside-top" }, [
                              _vm._v(
                                "\n                仅供参与方查阅，不用于签署（共\n                " +
                                  _vm._s(this.enclosureFilesList.length) +
                                  " 份）\n                "
                              ),
                              _c("span", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function($event) {
                                    _vm.drawerShow = false
                                  }
                                }
                              })
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "aside-box",
                                style: { height: _vm.windowHeight - 120 + "px" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "enclosure-box" },
                                  _vm._l(_vm.enclosureFilesList, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "enclosure-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "li-preview" },
                                          [
                                            _vm.isImg(item) || _vm.isVideo(item)
                                              ? _c("span", {
                                                  staticClass: "el-icon-view",
                                                  attrs: { title: "预览" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.previewVideOrImg(
                                                        item
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm.isDoc(item)
                                              ? _c("span", {
                                                  staticClass: "el-icon-view",
                                                  attrs: { title: "预览" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.previewDoc(
                                                        item
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.downloadAttatchFile(
                                                    item
                                                  ),
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "el-icon-download",
                                                  attrs: { title: "下载" }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("div", { staticClass: "li-con" }, [
                                          _c("div", { staticClass: "t-do" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getEnclosureSuffix(item)
                                              )
                                            )
                                          ]),
                                          _c(
                                            "h1",
                                            { attrs: { title: item.fileName } },
                                            [_vm._v(_vm._s(item.fileName))]
                                          )
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm.enclosureFilesList.length === 0
                                  ? _c("no-data", {
                                      attrs: {
                                        slot: "empty",
                                        text: "暂无数据"
                                      },
                                      slot: "empty"
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "aside-tab",
                          class: _vm.drawerShow ? "open" : "close"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tab",
                              class: _vm.drawerShow ? "active" : "",
                              on: { click: _vm.openTab }
                            },
                            [
                              _c("i", { staticClass: "el-icon-circle-plus" }),
                              _c("span", { staticClass: "word" }, [
                                _vm._v("附属材料  ")
                              ]),
                              _c("i", {
                                class: _vm.drawerShow
                                  ? "el-icon-arrow-left"
                                  : "el-icon-arrow-right"
                              })
                            ]
                          )
                        ]
                      ),
                      _c(
                        "el-main",
                        {
                          staticClass: "main-content",
                          style: { height: _vm.boxHeight }
                        },
                        [
                          _c("contract-view", {
                            ref: "contractView",
                            attrs: {
                              "contract-info": _vm.currentInfo,
                              "chapter-list": _vm.chapteJson,
                              items: _vm.contractInfoTemporary.items,
                              page: _vm.currentInfo.page,
                              scaleValue: _vm.scaleValue,
                              targetId: _vm.contractInfoTemporary.targetId,
                              "show-chapter": true,
                              qifengChapList: _vm.qifengChapList,
                              "signatory-json": _vm.signatoryJson,
                              hideSignDate: _vm.contractInfo.hideSignDate
                            },
                            on: {
                              "update:contractInfo": function($event) {
                                _vm.currentInfo = $event
                              },
                              "update:contract-info": function($event) {
                                _vm.currentInfo = $event
                              },
                              "update:chapterList": function($event) {
                                _vm.chapteJson = $event
                              },
                              "update:chapter-list": function($event) {
                                _vm.chapteJson = $event
                              },
                              "update:scaleValue": function($event) {
                                _vm.scaleValue = $event
                              },
                              "update:scale-value": function($event) {
                                _vm.scaleValue = $event
                              },
                              updateQifeng: _vm.updateQifeng,
                              delQifeng: _vm.delQifeng,
                              "del-chapte": function($event) {
                                return _vm.delChapteByCindex($event)
                              },
                              "pre-page": function($event) {
                                return _vm.getContractDetailByNum($event)
                              },
                              "next-page": function($event) {
                                return _vm.getContractDetailByNum($event)
                              },
                              changeSmallMap: _vm.changeSmallMap,
                              toCurrentPage: _vm.toCurrentPage
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "contract-bottom" },
                            [
                              _vm.contractInfoTemporary &&
                              _vm.contractInfoTemporary.items &&
                              _vm.contractInfoTemporary.items > 1
                                ? [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          "text-align": "center"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.currentInfo.page) +
                                            "/" +
                                            _vm._s(
                                              _vm.contractInfoTemporary.items
                                            )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "light",
                                          placement: "left-start"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [_vm._v("回到首页")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "jumpFirst",
                                            on: {
                                              click: function($event) {
                                                return _vm.goPageAndFixed(1)
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../assets/images/btn-down.png")
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "light",
                                          placement: "left"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [_vm._v("上一页")]
                                        ),
                                        _c("span", {
                                          staticClass:
                                            "el-icon-arrow-up prev_next_span",
                                          on: {
                                            click: function($event) {
                                              return _vm.goPageAndFixed(
                                                _vm.currentInfo.page > 1
                                                  ? _vm.currentInfo.page - 1
                                                  : 1
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "light",
                                          placement: "left"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [_vm._v("下一页")]
                                        ),
                                        _c("span", {
                                          staticClass:
                                            "el-icon-arrow-down prev_next_span",
                                          on: {
                                            click: function($event) {
                                              return _vm.goPageAndFixed(
                                                _vm.contractInfoTemporary
                                                  .items > _vm.currentInfo.page
                                                  ? _vm.currentInfo.page + 1
                                                  : _vm.contractInfoTemporary
                                                      .items
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "light",
                                          placement: "left-end"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [_vm._v("回到尾页")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "jumpLast",
                                            on: {
                                              click: function($event) {
                                                return _vm.goPageAndFixed(
                                                  _vm.contractInfoTemporary
                                                    .items
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../assets/images/btn-down.png")
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    placement: "left-start"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            (_vm.beWord(
                                              _vm.fileList[_vm.checkAct]
                                                .fileName
                                            ) ||
                                              (_vm.fileList[_vm.checkAct]
                                                .useTo &&
                                                _vm.fileList[_vm.checkAct]
                                                  .useTo === 1)) &&
                                            !_vm.$route.query.multiFileKey,
                                          expression:
                                            "\n                    (beWord(fileList[checkAct].fileName) ||\n                      (fileList[checkAct].useTo &&\n                        fileList[checkAct].useTo === 1)) &&\n                    !$route.query.multiFileKey\n                  "
                                        }
                                      ],
                                      staticClass: "jump-edit",
                                      on: {
                                        click: function($event) {
                                          return _vm.InOnlyOffice(
                                            _vm.fileList[_vm.checkAct],
                                            _vm.checkAct
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-edit-outline",
                                        staticStyle: {
                                          "font-size": "20px",
                                          color: "#ec1c1c"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    placement: "left-start"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [_vm._v("设置骑缝章")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.contractInfoTemporary &&
                                            _vm.contractInfoTemporary.items &&
                                            _vm.contractInfoTemporary.items >
                                              1 &&
                                            _vm.qifengChapList.length,
                                          expression:
                                            "\n                    contractInfoTemporary &&\n                    contractInfoTemporary.items &&\n                    contractInfoTemporary.items > 1 &&\n                    qifengChapList.length\n                  "
                                        }
                                      ],
                                      staticClass: "jump-qifeng",
                                      on: {
                                        click: function($event) {
                                          return _vm.settingQIFENG()
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-s-check",
                                        staticStyle: {
                                          "font-size": "20px",
                                          color: "#ec1c1c"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          ),
                          false
                            ? _c("div", { staticClass: "page-number" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.goPageNum,
                                      expression: "goPageNum"
                                    }
                                  ],
                                  attrs: {
                                    placeholder: "输入页码",
                                    type: "number"
                                  },
                                  domProps: { value: _vm.goPageNum },
                                  on: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.handleContractPageClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.goPageNum = $event.target.value
                                    }
                                  }
                                }),
                                _c(
                                  "a",
                                  {
                                    staticClass: "inp-in",
                                    on: { click: _vm.handleContractPageClick }
                                  },
                                  [_vm._v("GO")]
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-aside",
                        {
                          staticClass: "aside-right",
                          style: { height: _vm.boxHeight },
                          attrs: { width: "2.80rem" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sign-position-sty pointer" },
                            [
                              _c(
                                "p",
                                { staticClass: "page-total" },
                                [
                                  _vm._v(
                                    "\n                设置签章位置\n                "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "bottom-end"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [
                                          _vm._v(
                                            "”每一份文件”至少设置一个签章位置，“每个签署方”至少设置一个签署位置"
                                          )
                                        ]
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question",
                                        staticStyle: { "margin-left": "4px" }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "list-signers" },
                            [
                              _vm.newSignJson
                                ? _vm._l(_vm.newSignJson, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        item.signOwner === "批量签署方"
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  key: index,
                                                  class: [
                                                    "qz-new",
                                                    {
                                                      enterprise_qz_new:
                                                        item.signatoryUserType
                                                    }
                                                  ],
                                                  attrs: { draggable: "true" },
                                                  on: {
                                                    dragend: function($event) {
                                                      return _vm.dragQZEnd(
                                                        $event,
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        draggable: "true"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleAddChapter(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("h1", [
                                                        _vm._v("签署方")
                                                      ]),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "point-num"
                                                        },
                                                        [
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "light",
                                                                placement:
                                                                  "bottom-end"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  attrs: {
                                                                    slot:
                                                                      "content"
                                                                  },
                                                                  slot:
                                                                    "content"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "表示该签署方在“当前文件”中设置的“签章位置”数量"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "n"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.signOwnerLen(
                                                                          item.signOwner
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "light",
                                                                placement:
                                                                  "bottom-end"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  attrs: {
                                                                    slot:
                                                                      "content"
                                                                  },
                                                                  slot:
                                                                    "content"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "表示该签署方在“所有文件”中设置的“签章位置”数量"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "l"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.signOwnerAll(
                                                                          item.signOwner
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "con con1"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "在各自收到的文件中，独自签署"
                                                          )
                                                        ]
                                                      ),
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("../../assets/images/move-icon.png")
                                                        }
                                                      }),
                                                      _vm.contractInfo
                                                        .hideSignDate
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "time"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "日期：XXXX"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  key: index,
                                                  ref: "step1",
                                                  refInFor: true,
                                                  class: [
                                                    "qz-new",
                                                    {
                                                      enterprise_qz_new:
                                                        item.signatoryUserType ===
                                                        1
                                                    }
                                                  ],
                                                  style: {
                                                    width:
                                                      item.signatoryUserType ===
                                                      1
                                                        ? 208
                                                        : 115,
                                                    height:
                                                      parseInt(
                                                        item.signatoryUserType ===
                                                          1
                                                          ? 230
                                                          : 101
                                                      ) -
                                                      parseInt(
                                                        _vm.contractInfo
                                                          .hideSignDate
                                                          ? 22
                                                          : 0
                                                      )
                                                  },
                                                  attrs: {
                                                    draggable: "true",
                                                    id: "step1"
                                                  },
                                                  on: {
                                                    dragend: function($event) {
                                                      return _vm.dragQZEnd(
                                                        $event,
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        draggable: "true"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleAddChapter(
                                                            item,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("h1", [
                                                        _vm._v("签署方")
                                                      ]),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "point-num"
                                                        },
                                                        [
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "light",
                                                                placement:
                                                                  "bottom-end"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  attrs: {
                                                                    slot:
                                                                      "content"
                                                                  },
                                                                  slot:
                                                                    "content"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "表示该签署方在“当前文件”中设置的“签章位置”数量"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  ref: "step2",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "n",
                                                                  attrs: {
                                                                    id: "step2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.signOwnerLen(
                                                                          item.signOwner
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "light",
                                                                placement:
                                                                  "bottom-end"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  attrs: {
                                                                    slot:
                                                                      "content"
                                                                  },
                                                                  slot:
                                                                    "content"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "表示该签署方在“所有文件”中设置的“签章位置”数量"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  ref: "step3",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "l",
                                                                  attrs: {
                                                                    id: "step3"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.signOwnerAll(
                                                                          item.signOwner
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            "con",
                                                            {
                                                              enterprise_con:
                                                                item.signatoryUserType ===
                                                                1
                                                            }
                                                          ],
                                                          style: {
                                                            paddingTop: item.forge
                                                              ? "2px"
                                                              : "18px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              class: {
                                                                line_clamp2:
                                                                  item.forge
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "eclipse"
                                                                    )(
                                                                      (item.forge
                                                                        ? "经办人-"
                                                                        : "") +
                                                                        " " +
                                                                        item.name
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("../../assets/images/move-icon.png")
                                                        }
                                                      }),
                                                      _vm.contractInfo
                                                        .hideSignDate
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "time"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "日期：XXXX"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "right-bottom" },
                            [
                              _c(
                                "el-button",
                                {
                                  class: {
                                    "g-save-disable": _vm.isSaveDisable
                                  },
                                  attrs: {
                                    type: "danger",
                                    disabled: _vm.isSaveDisable,
                                    size: "mini"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sendContractToCreateNow(false)
                                    }
                                  }
                                },
                                [_vm._v("立即发起")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: { click: _vm.backStep }
                                },
                                [_vm._v("上一步")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm.guideStep && false
                        ? _c("div", { staticClass: "apply-guide" }, [
                            _c("div", { ref: "guideBox", staticClass: "box" }, [
                              _vm.guideStep !== "step4"
                                ? _c(
                                    "div",
                                    {
                                      ref: "tooltip",
                                      staticClass: "tooltip tooltip-bottom"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.guideStep === "step1",
                                              expression:
                                                "guideStep === 'step1'"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._m(0),
                                          _c(
                                            "div",
                                            { staticClass: "tooltiop-btns" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void (0)"
                                                  },
                                                  on: {
                                                    click: _vm.guideApplyCancel
                                                  }
                                                },
                                                [_vm._v("关闭引导")]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void (0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.guideApply(
                                                        "step2"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("signatoryJson")]
                                              )
                                            ]
                                          ),
                                          _c("div", {
                                            staticClass: "tooltip-arrow",
                                            staticStyle: { left: "65%" }
                                          })
                                        ]
                                      ),
                                      _vm.guideStep === "step2"
                                        ? [
                                            _vm._m(1),
                                            _c(
                                              "div",
                                              { staticClass: "tooltiop-btns" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideApply(
                                                          "step1"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("上一步")]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideApply(
                                                          "step3"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("下一步")]
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "tooltip-arrow",
                                              staticStyle: { left: "92%" }
                                            })
                                          ]
                                        : _vm._e(),
                                      _vm.guideStep === "step3"
                                        ? [
                                            _vm._m(2),
                                            _c(
                                              "div",
                                              { staticClass: "tooltiop-btns" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideApply(
                                                          "step2"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("上一步")]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.guideApplyCancel
                                                    }
                                                  },
                                                  [_vm._v("知道了")]
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "tooltip-arrow",
                                              staticStyle: { left: "75%" }
                                            })
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-container",
                { staticClass: "to-create" },
                [
                  _c(
                    "el-main",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.batchLoading,
                          expression: "batchLoading"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.nextstep,
                          expression: "!nextstep"
                        }
                      ],
                      staticClass: "cont-info-form"
                    },
                    [
                      _vm.guideSignStep && false
                        ? _c("div", { staticClass: "apply-sign-guide" })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          ref: "guideBox",
                          staticClass: "apply-sign-guide-box"
                        },
                        [
                          _vm.guideSignStep !== "signStep6"
                            ? _c(
                                "div",
                                [
                                  _vm.guideSignStep === "signStep1"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tooltip tooltip-bottom tool"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "tooltip-text" },
                                              [
                                                _c("span", [_vm._v("1")]),
                                                _vm._v(
                                                  "确认发起主体是否正确\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "tooltiop-btns" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.guideSignApplyCancel
                                                    }
                                                  },
                                                  [_vm._v("关闭引导")]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideSignApply(
                                                          "signStep3"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("下一步")]
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "tooltip-arrow",
                                              staticStyle: { left: "45%" }
                                            })
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm.guideSignStep === "signStep3"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tooltip tooltip-bottom1 tool"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "tooltip-text" },
                                              [
                                                _c("span", [_vm._v("2")]),
                                                _vm._v(
                                                  "上传签署文件\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "tooltiop-btns" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideSignApply(
                                                          "signStep1"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("上一步")]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideSignApply(
                                                          "signStep4"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("下一步")]
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "tooltip-arrow",
                                              staticStyle: { left: "62%" }
                                            })
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm.guideSignStep === "signStep4"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tooltip tooltip-bottom tool"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "tooltip-text" },
                                              [
                                                _c("span", [_vm._v("3")]),
                                                _vm._v(
                                                  "添加文件签署（接收）方信息\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "tooltiop-btns" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideSignApply(
                                                          "signStep3"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("上一步")]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.guideSignApplyCancel
                                                    }
                                                  },
                                                  [_vm._v("知道了")]
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "tooltip-arrow",
                                              staticStyle: { left: "92%" }
                                            })
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm.guideSignStep === "signStep5"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tooltip tooltip-top tool"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "tooltip-text" },
                                              [
                                                _c("span", [_vm._v("4")]),
                                                _vm._v(
                                                  "设置文件签署位置\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "tooltiop-btns" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.guideSignApply(
                                                          "signStep4"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("上一步")]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "javascript:void (0)"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.guideSignApplyCancel
                                                    }
                                                  },
                                                  [_vm._v("知道了")]
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "tooltip-arrow",
                                              staticStyle: { left: "75%" }
                                            })
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "tabs-card" },
                        [
                          _c("div", { ref: "tab", staticClass: "tabs-wrap" }, [
                            _c(
                              "ul",
                              { ref: "tabitem" },
                              [
                                _vm._l(_vm.totalAccountList, function(
                                  user,
                                  index
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            user.userStemFrom !== -16 ||
                                            _vm.totalAccountList.length === 1,
                                          expression:
                                            "\n                      user.userStemFrom !== -16 || totalAccountList.length === 1\n                    "
                                        }
                                      ],
                                      key: index,
                                      ref: "signStep1",
                                      refInFor: true,
                                      class:
                                        _vm.currentUser &&
                                        _vm.currentUser.corpUserId ===
                                          user.corpUserId
                                          ? "current"
                                          : "",
                                      attrs: {
                                        id: "signStep1",
                                        title:
                                          user.corpName ||
                                          user.name ||
                                          user.username
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.changeAccount(user, $event)
                                        }
                                      }
                                    },
                                    [
                                      user.userStemFrom === -16 &&
                                      !_vm.isInDingTalk
                                        ? _c("img", {
                                            attrs: {
                                              src: "/images/icon/dingIcon.png",
                                              alt: "钉钉",
                                              width: "20px"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            user.corpName ||
                                              user.name ||
                                              user.username
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                }),
                                _c(
                                  "router-link",
                                  { attrs: { to: "/viewIndex" } },
                                  [
                                    _vm.isInDingTalk
                                      ? _c("li", [_vm._v("返回首页")])
                                      : _vm._e()
                                  ]
                                )
                              ],
                              2
                            )
                          ]),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.totalAccountList.length > 5,
                                  expression: "totalAccountList.length > 5"
                                }
                              ],
                              staticClass: "more-bg"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "more-down",
                                  on: { click: _vm.showMoreUser }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.showAllUser
                                          ? "#ec1c1c"
                                          : "#000000"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showAllUser ? "收起" : "更多"
                                        )
                                      )
                                    ]
                                  ),
                                  _c("i", {
                                    class: _vm.showAllUser
                                      ? "el-icon-caret-top"
                                      : "el-icon-caret-bottom"
                                  })
                                ]
                              )
                            ]
                          ),
                          _c("div", { staticClass: "pad-bom" }),
                          _c("goto-auth", {
                            attrs: { authDialog: _vm.authDialog },
                            on: {
                              "update:authDialog": function($event) {
                                _vm.authDialog = $event
                              },
                              "update:auth-dialog": function($event) {
                                _vm.authDialog = $event
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-collapse-transition", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showAllUser,
                                expression: "showAllUser"
                              }
                            ]
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-tit" }, [
                                _vm._v("选择发起主体")
                              ]),
                              _c("div", { staticClass: "card-box" }, [
                                _c(
                                  "div",
                                  { staticClass: "user-list" },
                                  _vm._l(_vm.totalAccountList, function(
                                    user,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              user.userStemFrom !== -16 ||
                                              _vm.totalAccountList.length === 1,
                                            expression:
                                              "\n                          user.userStemFrom !== -16 ||\n                          totalAccountList.length === 1\n                        "
                                          }
                                        ],
                                        key: index,
                                        staticClass: "user",
                                        class:
                                          _vm.$store.getters.currentAuthUser &&
                                          _vm.$store.getters.currentAuthUser
                                            .corpUserId === user.corpUserId
                                            ? "current"
                                            : "",
                                        on: {
                                          click: function($event) {
                                            return _vm.changeAccount(
                                              user,
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        user.userStemFrom === -16 &&
                                        !_vm.isInDingTalk
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  "/images/icon/dingIcon.png",
                                                alt: "钉钉",
                                                width: "20px"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              user.corpName ||
                                                user.signatoryFullName ||
                                                user.username
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          ]
                        )
                      ]),
                      _c(
                        "el-form",
                        {
                          ref: "contForm",
                          staticClass: "cont-form",
                          attrs: {
                            size: "small",
                            model: _vm.contractInfo,
                            "label-position": "left",
                            rules: _vm.contractNameRules
                          }
                        },
                        [
                          _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "card-tit" }, [
                              _vm._v(
                                "\n                  待审阅的文件  \n                  "
                              ),
                              _c(
                                "span",
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "bottom-end"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [
                                          _vm._v(
                                            "\n                        电子签名不适用文件:\n                        "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "1.涉及婚姻、收养、继承等人身关系的；\n                        "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "2.涉及停止供水、供热、供气等公用事业服务的；\n                        "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "3.法律、行政法规规定的不适用电子文书的其他情形。\n                      "
                                          )
                                        ]
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-question"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-left": "12px"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.fileList.length) + "/30")]
                              )
                            ]),
                            _c("div", { staticClass: "card-box" }, [
                              _c(
                                "div",
                                { staticClass: "file-list" },
                                [
                                  _c(
                                    "draggable",
                                    {
                                      staticClass: "file-draggable",
                                      attrs: {
                                        element: "ul",
                                        list: _vm.fileList,
                                        options: {
                                          handle: ".icon-move_box",
                                          animation: 200,
                                          ghostClass: "ghost"
                                        },
                                        move: _vm.draggingMove,
                                        filter: ".upload-btn"
                                      },
                                      on: {
                                        start: function($event) {
                                          _vm.dragging = true
                                        },
                                        end: function($event) {
                                          _vm.dragging = false
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.$route.query
                                                .multiFileKey
                                                ? false
                                                : true,
                                              expression:
                                                "$route.query.multiFileKey ? false : true"
                                            }
                                          ],
                                          ref: "signStep3",
                                          staticClass: "upload-btn",
                                          attrs: {
                                            id: "signStep3",
                                            title: "小于60M的doc、docx文件"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-upload",
                                            {
                                              attrs: {
                                                action: "#",
                                                accept: ".doc, .docx",
                                                multiple: "",
                                                limit: 30,
                                                "before-upload":
                                                  _vm.fileOnBeforeUpload,
                                                "on-exceed":
                                                  _vm.fileHandleExceed,
                                                "show-file-list": false,
                                                "file-list": _vm.fileList,
                                                "on-error": _vm.fileOnError,
                                                "on-success": _vm.fileOnSuccess
                                              }
                                            },
                                            [
                                              _vm._t("default", function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upload-content"
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "el-icon-plus"
                                                      }),
                                                      _c(
                                                        "p",
                                                        { staticClass: "tip" },
                                                        [_vm._v("上传文件")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              })
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._l(_vm.fileList, function(
                                        file,
                                        index
                                      ) {
                                        return [
                                          _c(
                                            "transition-group",
                                            {
                                              key: index,
                                              attrs: { type: "transition" }
                                            },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass: "upload-file"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "bx" },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: _vm.fileIcon(
                                                            file
                                                          )
                                                        }
                                                      }),
                                                      _c(
                                                        "div",
                                                        { staticClass: "msk" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "msk-icon"
                                                            },
                                                            [
                                                              _c(
                                                                "el-tooltip",
                                                                {
                                                                  attrs: {
                                                                    effect:
                                                                      "dark",
                                                                    content:
                                                                      "预览",
                                                                    placement:
                                                                      "bottom-start"
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: !file.isTpl,
                                                                        expression:
                                                                          "!file.isTpl"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "el-icon-view pointer",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.previewDoc(
                                                                          file
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _c(
                                                                "el-tooltip",
                                                                {
                                                                  attrs: {
                                                                    effect:
                                                                      "dark",
                                                                    content:
                                                                      "编辑",
                                                                    placement:
                                                                      "bottom-start"
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value:
                                                                          (_vm.beWord(
                                                                            file.fileName
                                                                          ) ||
                                                                            (file.useTo &&
                                                                              file.useTo ===
                                                                                1)) &&
                                                                          !_vm
                                                                            .$route
                                                                            .query
                                                                            .multiFileKey,
                                                                        expression:
                                                                          "\n                                        (beWord(file.fileName) ||\n                                          (file.useTo && file.useTo === 1)) &&\n                                        !$route.query.multiFileKey\n                                      "
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "el-icon-edit pointer",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.InOnlyOffice(
                                                                          file,
                                                                          index
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _c(
                                                                "el-tooltip",
                                                                {
                                                                  attrs: {
                                                                    effect:
                                                                      "dark",
                                                                    content:
                                                                      "删除",
                                                                    placement:
                                                                      "bottom-start"
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-delete-solid pointer",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeFile(
                                                                          index,
                                                                          file
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "title",
                                                      attrs: {
                                                        title: file.fileName
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          file.fileName ||
                                                            file.tplName +
                                                              "模板"
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _c("div", { staticClass: "card-box" }, [
                                _c(
                                  "div",
                                  { staticClass: "enclosureFiles" },
                                  [
                                    _vm._v(
                                      "\n                      附属材料  \n                      "
                                    ),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "light",
                                              placement: "bottom-end"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "附属材料仅供参与方查阅，不用于签署"
                                                )
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                              staticStyle: {
                                                display: "inline-block",
                                                "font-size": "16px",
                                                cursor: "pointer",
                                                color: "#a1a1a1"
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          margin: "0 12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.enclosureFilesList.length
                                          ) + "/30"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          action: "#",
                                          multiple: "",
                                          "show-file-list": false,
                                          "file-list": _vm.enclosureFilesList,
                                          "before-upload":
                                            _vm.enclosureFilesBeforeUpload,
                                          limit: 30,
                                          "on-exceed":
                                            _vm.enclosureFilesHandleExceed,
                                          "on-error": _vm.enclosureFilesError
                                        }
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-plus",
                                            size: "small"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._l(_vm.enclosureFilesList, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "enclosureFiles-item"
                                        },
                                        [
                                          _c("div", { staticClass: "desc" }, [
                                            _vm._v(_vm._s(item.fileName))
                                          ]),
                                          _c("span", {
                                            staticClass:
                                              "el-icon-error del-btn",
                                            on: {
                                              click: function($event) {
                                                return _vm.delEnclosureFiles(
                                                  index
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.fileList.length > 0 &&
                                        !_vm.collaborationType,
                                      expression:
                                        "fileList.length > 0 && !collaborationType"
                                    }
                                  ],
                                  staticClass: "otherSet"
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-right": "40px",
                                        display: "inline-block"
                                      },
                                      attrs: {
                                        label: "文件主题名称",
                                        "label-width": "100px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        ref: "signStep2",
                                        staticStyle: { width: "317px" },
                                        attrs: {
                                          id: "signStep2",
                                          placeholder: "请输入主题名称"
                                        },
                                        on: { blur: _vm.validContractName },
                                        model: {
                                          value: _vm.contractInfo.contractName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.contractInfo,
                                              "contractName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "contractInfo.contractName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "margin-right": "40px"
                                      },
                                      attrs: { "label-width": _vm.labelWidth }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("签署链接有效期  ")
                                          ]),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "light",
                                                placement: "bottom-end"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            在指定日期之后，签署方若未完成文件签署，\n                            "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "签署方接收到的签署 “ 短信/邮件 ” 链接\n                            "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "将失效\n                          "
                                                  )
                                                ]
                                              ),
                                              _c("i", {
                                                staticClass: "el-icon-question",
                                                staticStyle: {
                                                  "font-size": "16px",
                                                  cursor: "pointer",
                                                  color: "#a1a1a1"
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("el-date-picker", {
                                        staticClass: "datep",
                                        staticStyle: {
                                          width: "317px",
                                          "margin-left": "-25px",
                                          "text-align": "center"
                                        },
                                        attrs: {
                                          type: "date",
                                          format: "yyyy-MM-dd",
                                          "value-format": "yyyy-MM-dd",
                                          "picker-options": _vm.pickerOptions,
                                          clearable: _vm.clearable,
                                          placeholder: "选择日期"
                                        },
                                        on: { change: _vm.pickTime },
                                        model: {
                                          value: _vm.signlinktime,
                                          callback: function($$v) {
                                            _vm.signlinktime = $$v
                                          },
                                          expression: "signlinktime"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  !_vm.isGroup && false
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bow",
                                          attrs: { label: "支付方式" }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: { placeholder: "请选择" },
                                              model: {
                                                value:
                                                  _vm.contractInfo.consumMode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.contractInfo,
                                                    "consumMode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "contractInfo.consumMode"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "发起方支付全部费用",
                                                  value: 0
                                                }
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label:
                                                    "各方各自支付自己的费用",
                                                  value: 1
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ]),
                          !_vm.collaborationType
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "f-center" },
                                  [
                                    _c("el-form-item", [
                                      _c("div", { staticClass: "h4" }, [
                                        _c("i"),
                                        _vm._v(
                                          "签署设置\n                      "
                                        ),
                                        _c("div", { staticClass: "wp" }, [
                                          _c("div", { staticClass: "radio" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "more-set",
                                                on: {
                                                  click: function($event) {
                                                    _vm.showMoreSet = !_vm.showMoreSet
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.showMoreSet
                                                        ? "收起<<"
                                                        : "我的偏好>>"
                                                    ) +
                                                    "\n                          "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.showMoreSet,
                                                    expression: "showMoreSet"
                                                  }
                                                ]
                                              },
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      effect: "light",
                                                      placement: "bottom-end"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          slot: "content"
                                                        },
                                                        slot: "content"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                测试签约流程时，可关闭数字证书，正式签"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                                署时带数字证书可进一步保障签约有效性。\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-checkbox",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.activeTabsName !=
                                                              _vm.signTypes[2],
                                                            expression:
                                                              "activeTabsName != signTypes[2]"
                                                          }
                                                        ],
                                                        attrs: {
                                                          disabled:
                                                            _vm.contractInfo
                                                              .consumMode == 1,
                                                          "true-label": 1,
                                                          "false-label": 0
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.handleChangeCa
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.contractInfo
                                                              .serverCa,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.contractInfo,
                                                              "serverCa",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "contractInfo.serverCa"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                数字证书\n                                "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-question",
                                                          staticStyle: {
                                                            "font-size": "16px",
                                                            "margin-left":
                                                              "10px",
                                                            color: "#a1a1a1"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-checkbox",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.activeTabsName !=
                                                          _vm.signTypes[2],
                                                        expression:
                                                          "activeTabsName != signTypes[2]"
                                                      }
                                                    ],
                                                    attrs: {
                                                      "true-label": 1,
                                                      "false-label": 0
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.contractInfo
                                                          .needPresSign,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.contractInfo,
                                                          "needPresSign",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "contractInfo.needPresSign"
                                                    }
                                                  },
                                                  [_vm._v("保全章")]
                                                ),
                                                _c(
                                                  "el-checkbox",
                                                  {
                                                    attrs: {
                                                      "true-label": 1,
                                                      "false-label": 0
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.qiFengSign
                                                          .enterpriseSign,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.qiFengSign,
                                                          "enterpriseSign",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "qiFengSign.enterpriseSign"
                                                    }
                                                  },
                                                  [_vm._v("企业骑缝章")]
                                                ),
                                                _c(
                                                  "el-checkbox",
                                                  {
                                                    attrs: {
                                                      "true-label": 1,
                                                      "false-label": 0
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.qiFengSign
                                                          .personSign,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.qiFengSign,
                                                          "personSign",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "qiFengSign.personSign"
                                                    }
                                                  },
                                                  [_vm._v("个人骑缝章")]
                                                ),
                                                _c(
                                                  "el-checkbox",
                                                  {
                                                    attrs: {
                                                      "true-label": 1,
                                                      "false-label": 0
                                                    },
                                                    model: {
                                                      value: _vm.personImgSign,
                                                      callback: function($$v) {
                                                        _vm.personImgSign = $$v
                                                      },
                                                      expression:
                                                        "personImgSign"
                                                    }
                                                  },
                                                  [_vm._v("个人仅可使用图形章")]
                                                ),
                                                _c(
                                                  "el-checkbox",
                                                  {
                                                    attrs: {
                                                      "true-label": 1,
                                                      "false-label": 0
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.contractInfo
                                                          .hideSignDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.contractInfo,
                                                          "hideSignDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "contractInfo.hideSignDate"
                                                    }
                                                  },
                                                  [_vm._v("签章时间")]
                                                ),
                                                _c(
                                                  "el-checkbox",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.waterConfig.switch,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.waterConfig,
                                                          "switch",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "waterConfig.switch"
                                                    }
                                                  },
                                                  [_vm._v("文件水印 ")]
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-setting",
                                                  staticStyle: {
                                                    cursor: "pointer"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.setWatermarkVisible = true
                                                    }
                                                  }
                                                }),
                                                !_vm.isInDingTalk
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "prtf-sty",
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          "line-height": "20px",
                                                          border:
                                                            "1px solid #888888",
                                                          "border-radius":
                                                            "4px",
                                                          padding: "4px 10px"
                                                        },
                                                        on: {
                                                          click: _vm.turnPref
                                                        }
                                                      },
                                                      [_vm._v("偏好设置")]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ])
                                        ])
                                      ]),
                                      _c("input", {
                                        ref: "importBatchFile",
                                        staticStyle: {
                                          display: "none",
                                          width: "0",
                                          height: "0",
                                          visibility: "hidden"
                                        },
                                        attrs: { type: "file" },
                                        on: {
                                          change: function($event) {
                                            return _vm.batchFileChange()
                                          }
                                        }
                                      })
                                    ]),
                                    _c(
                                      "el-form-item",
                                      [
                                        !_vm.isInDingTalk
                                          ? _c(
                                              "el-tabs",
                                              {
                                                attrs: {
                                                  stretch: true,
                                                  "before-leave":
                                                    _vm.tabHandleBefore
                                                },
                                                on: {
                                                  "tab-click":
                                                    _vm.handleTabsClick
                                                },
                                                model: {
                                                  value: _vm.activeTabsName,
                                                  callback: function($$v) {
                                                    _vm.activeTabsName = $$v
                                                  },
                                                  expression: "activeTabsName"
                                                }
                                              },
                                              [
                                                _c("el-tab-pane", {
                                                  attrs: {
                                                    label: "快捷签",
                                                    name: _vm.signTypes[0]
                                                  }
                                                }),
                                                _c("el-tab-pane", {
                                                  attrs: {
                                                    label: "视频签",
                                                    name: _vm.signTypes[1]
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c("el-form-item", [
                                      _c(
                                        "div",
                                        { staticClass: "tab" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.activeTabsName ===
                                                    _vm.signTypes[2],
                                                  expression:
                                                    "activeTabsName === signTypes[2]"
                                                }
                                              ],
                                              staticClass: "tips-lab-sty"
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-warning",
                                                staticStyle: {
                                                  color: "#f8b762",
                                                  margin: "0 10px"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                        为适配全球多法域合规要求，保障签署文件的跨境法律效力，国际签采用 SES 形式进行操作，如签署方所在地有法律法规要求，需要使用AES/QES，请联系客服或商务\n                      "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "tab-top" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.activeTabsName !=
                                                        _vm.signTypes[1],
                                                      expression:
                                                        "activeTabsName != signTypes[1]"
                                                    }
                                                  ],
                                                  staticClass: "top-left"
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      model: {
                                                        value:
                                                          _vm.contractInfo
                                                            .ifOrder,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.contractInfo,
                                                            "ifOrder",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "contractInfo.ifOrder"
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("按顺序签署")
                                                      ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flow-box",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.visibleSigningFlow = true
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/images/icon/icon-box.png",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v("签署流程图")
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("div", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.activeTabsName ==
                                                      _vm.signTypes[1],
                                                    expression:
                                                      "activeTabsName == signTypes[1]"
                                                  }
                                                ],
                                                staticClass: "top-left"
                                              }),
                                              _c(
                                                "div",
                                                { staticClass: "top-right" },
                                                [
                                                  _c(
                                                    "el-checkbox-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.activeTabsName !=
                                                            _vm.signTypes[1],
                                                          expression:
                                                            "activeTabsName != signTypes[1]"
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        position: "relative",
                                                        "margin-bottom": "2px",
                                                        width: "80px",
                                                        "text-align": "center"
                                                      },
                                                      attrs: {
                                                        "true-label": 11,
                                                        "false-label": null
                                                      },
                                                      model: {
                                                        value: _vm.checkedBatch,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.checkedBatch = $$v
                                                        },
                                                        expression:
                                                          "checkedBatch"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            批量添加\n                            "
                                                      ),
                                                      _c("img", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.checkedBatch,
                                                            expression:
                                                              "checkedBatch"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "check-act",
                                                        attrs: {
                                                          src:
                                                            "/images/selected.png",
                                                          alt: ""
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.activeTabsName !=
                                                            _vm.signTypes[1],
                                                          expression:
                                                            "activeTabsName != signTypes[1]"
                                                        }
                                                      ],
                                                      attrs: {
                                                        effect: "light",
                                                        placement: "bottom-end"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            slot: "content"
                                                          },
                                                          slot: "content"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                              将相同内容的文件（如：学校放假通知\n                              "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "书、安全告知函等）同时发给不同签署\n                              "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "方，各个签署方分别各自签署。\n                            "
                                                          )
                                                        ]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-question",
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                          cursor: "pointer",
                                                          margin:
                                                            "0 10px 0 10px",
                                                          color: "#a1a1a1"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  [
                                                    _vm.regularList.length >
                                                      0 &&
                                                    this.signatoryJson.length <
                                                      10
                                                      ? _c(
                                                          "el-popover",
                                                          {
                                                            attrs: {
                                                              placement:
                                                                "right",
                                                              width: "200"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "popover-style"
                                                              },
                                                              [
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    attrs: {
                                                                      size:
                                                                        "small"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.regularlistPush(
                                                                          1
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "固定签署方"
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    attrs: {
                                                                      size:
                                                                        "small"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.addSignerList
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "自定义签署方"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "temone add",
                                                                attrs: {
                                                                  slot:
                                                                    "reference"
                                                                },
                                                                slot:
                                                                  "reference"
                                                              },
                                                              [
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    ref:
                                                                      "signStep4",
                                                                    staticStyle: {
                                                                      width:
                                                                        "80px",
                                                                      "text-align":
                                                                        "center",
                                                                      padding:
                                                                        "9px 0"
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "danger",
                                                                      id:
                                                                        "signStep4",
                                                                      size:
                                                                        "small"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "添加签署方"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "el-button",
                                                          {
                                                            ref: "signStep4",
                                                            staticStyle: {
                                                              width: "80px",
                                                              "text-align":
                                                                "center",
                                                              padding: "9px 0"
                                                            },
                                                            attrs: {
                                                              type: "danger",
                                                              id: "signStep4",
                                                              size: "small"
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.addSignerList
                                                            }
                                                          },
                                                          [_vm._v("添加签署方")]
                                                        ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#888888",
                                                          "font-size": "12px",
                                                          "margin-left": "12px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.signatoryJson
                                                              .length
                                                          ) + "/10"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ],
                                                2
                                              )
                                            ]
                                          ),
                                          _vm.signatoryJson &&
                                          _vm.signatoryJson.length
                                            ? _c(
                                                "div",
                                                { staticClass: "list-box" },
                                                [
                                                  _c(
                                                    "draggable",
                                                    {
                                                      attrs: {
                                                        list: _vm.signatoryJson,
                                                        options: {
                                                          handle:
                                                            ".icon-move_box",
                                                          animation: 200,
                                                          ghostClass: "ghost"
                                                        },
                                                        move: function() {
                                                          return this$1
                                                            .contractInfo
                                                            .ifOrder
                                                        }
                                                      },
                                                      on: {
                                                        start: function(
                                                          $event
                                                        ) {
                                                          _vm.dragging = true
                                                        },
                                                        end: function($event) {
                                                          _vm.dragging = false
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          attrs: {
                                                            type: "transition"
                                                          }
                                                        },
                                                        [
                                                          _vm._l(
                                                            _vm.signatoryJson,
                                                            function(item, i) {
                                                              return [
                                                                item.signOwner ===
                                                                "批量签署方"
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        key: i
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "batch-sign-box"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "sign-item batch-sign"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              _vm
                                                                                                .contractInfo
                                                                                                .ifOrder,
                                                                                            expression:
                                                                                              "contractInfo.ifOrder"
                                                                                          }
                                                                                        ],
                                                                                        staticClass:
                                                                                          "icon-move_box"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              _vm
                                                                                                .contractInfo
                                                                                                .ifOrder,
                                                                                            expression:
                                                                                              "contractInfo.ifOrder"
                                                                                          }
                                                                                        ],
                                                                                        staticStyle: {
                                                                                          width:
                                                                                            "26px",
                                                                                          "text-align":
                                                                                            "right"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            i +
                                                                                              1
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "user-type"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                    批量签署方\n                                    "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticStyle: {
                                                                                          color:
                                                                                            "rgba(0, 0, 0, 0.45)",
                                                                                          "font-size":
                                                                                            "12px",
                                                                                          "margin-left":
                                                                                            "5px"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm
                                                                                              .batchArray
                                                                                              .length
                                                                                          ) +
                                                                                            "/100"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      float:
                                                                                        "right"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs: {
                                                                                          size:
                                                                                            "mini"
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.batchClearAll()
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "清空签署方"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs: {
                                                                                          size:
                                                                                            "mini"
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.batchAdd()
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "添加签署方"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "col",
                                                                                staticStyle: {
                                                                                  width:
                                                                                    "31px"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      display:
                                                                                        "inline-block",
                                                                                      width:
                                                                                        "16px",
                                                                                      "margin-left":
                                                                                        "24px"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm
                                                                                      .signatoryJson
                                                                                      .length >
                                                                                    1
                                                                                      ? _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "el-icon-delete",
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.delSignList(
                                                                                                  item
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-row",
                                                                          {
                                                                            ref:
                                                                              "contractListTab",
                                                                            refInFor: true
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "contractList-box"
                                                                              },
                                                                              [
                                                                                _vm
                                                                                  .batchArray
                                                                                  .length ===
                                                                                0
                                                                                  ? [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "empty-box"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "btn-box"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "btn",
                                                                                                  on: {
                                                                                                    click: function(
                                                                                                      $event
                                                                                                    ) {
                                                                                                      return _vm.downloadTemplate()
                                                                                                    }
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "i",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "el-icon-folder"
                                                                                                    }
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    "下载批量模板\n                                          "
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "btn",
                                                                                                  on: {
                                                                                                    click: function(
                                                                                                      $event
                                                                                                    ) {
                                                                                                      return _vm.batchImport()
                                                                                                    }
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "i",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "el-icon-folder"
                                                                                                    }
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    "导入签署方\n                                          "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "p",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "\n                                          下载导入模板》按模板要求填入需要导入的签署方信息\n                                          》选择导入签署方\n                                        "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticStyle: {
                                                                                                color:
                                                                                                  "#666666"
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "此处添加的签署方，会按“签署方”生成对应套数的文件（即在各自收到的文件中独立签署互不干扰），只是这些签署方在文件中签章的位置相同"
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  : _vm._e(),
                                                                                _vm._l(
                                                                                  _vm.batchArray,
                                                                                  function(
                                                                                    t,
                                                                                    m
                                                                                  ) {
                                                                                    return [
                                                                                      _c(
                                                                                        "el-form",
                                                                                        {
                                                                                          key: m,
                                                                                          ref:
                                                                                            "contractBatchListTab",
                                                                                          refInFor: true,
                                                                                          attrs: {
                                                                                            model: t,
                                                                                            size:
                                                                                              "small"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              class: {
                                                                                                item: true,
                                                                                                "sign-item": true,
                                                                                                "i-drag":
                                                                                                  _vm
                                                                                                    .contractInfo
                                                                                                    .ifOrder
                                                                                              },
                                                                                              staticStyle: {
                                                                                                "padding-left":
                                                                                                  "10px"
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "col",
                                                                                                      staticStyle: {
                                                                                                        width:
                                                                                                          "70px"
                                                                                                      }
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "el-form-item",
                                                                                                        [
                                                                                                          _c(
                                                                                                            "el-select",
                                                                                                            {
                                                                                                              staticClass:
                                                                                                                "select",
                                                                                                              staticStyle: {
                                                                                                                width:
                                                                                                                  "70px"
                                                                                                              },
                                                                                                              attrs: {
                                                                                                                size:
                                                                                                                  "small"
                                                                                                              },
                                                                                                              on: {
                                                                                                                change: function(
                                                                                                                  $event
                                                                                                                ) {
                                                                                                                  return _vm.handleSignBatchUserType(
                                                                                                                    t,
                                                                                                                    m
                                                                                                                  )
                                                                                                                }
                                                                                                              },
                                                                                                              model: {
                                                                                                                value:
                                                                                                                  t.signatoryUserType,
                                                                                                                callback: function(
                                                                                                                  $$v
                                                                                                                ) {
                                                                                                                  _vm.$set(
                                                                                                                    t,
                                                                                                                    "signatoryUserType",
                                                                                                                    $$v
                                                                                                                  )
                                                                                                                },
                                                                                                                expression:
                                                                                                                  "t.signatoryUserType"
                                                                                                              }
                                                                                                            },
                                                                                                            [
                                                                                                              _c(
                                                                                                                "el-option",
                                                                                                                {
                                                                                                                  attrs: {
                                                                                                                    value: 0,
                                                                                                                    label:
                                                                                                                      "个人"
                                                                                                                  }
                                                                                                                }
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "el-option",
                                                                                                                {
                                                                                                                  attrs: {
                                                                                                                    value: 1,
                                                                                                                    label:
                                                                                                                      "企业"
                                                                                                                  }
                                                                                                                }
                                                                                                              )
                                                                                                            ],
                                                                                                            1
                                                                                                          )
                                                                                                        ],
                                                                                                        1
                                                                                                      )
                                                                                                    ],
                                                                                                    1
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "col",
                                                                                                      staticStyle: {
                                                                                                        width:
                                                                                                          "230px"
                                                                                                      }
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "el-form-item",
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            prop:
                                                                                                              "account",
                                                                                                            rules:
                                                                                                              t.signatoryUserType ==
                                                                                                              1
                                                                                                                ? _vm
                                                                                                                    .rulesTab
                                                                                                                    .account
                                                                                                                : _vm
                                                                                                                    .rulesTab
                                                                                                                    .mobile
                                                                                                          }
                                                                                                        },
                                                                                                        [
                                                                                                          _c(
                                                                                                            "el-input",
                                                                                                            {
                                                                                                              ref:
                                                                                                                "batchInputEmailOrPhone",
                                                                                                              refInFor: true,
                                                                                                              staticStyle: {
                                                                                                                width:
                                                                                                                  "230px"
                                                                                                              },
                                                                                                              attrs: {
                                                                                                                placeholder:
                                                                                                                  t.signatoryUserType ==
                                                                                                                  1
                                                                                                                    ? "签署方接收通知的手机/邮箱"
                                                                                                                    : "签署方接收通知的手机号"
                                                                                                              },
                                                                                                              on: {
                                                                                                                blur: function(
                                                                                                                  $event
                                                                                                                ) {
                                                                                                                  return _vm.getBatchUserInfoBySelectTargetId(
                                                                                                                    t.account,
                                                                                                                    m
                                                                                                                  )
                                                                                                                }
                                                                                                              },
                                                                                                              model: {
                                                                                                                value:
                                                                                                                  t.account,
                                                                                                                callback: function(
                                                                                                                  $$v
                                                                                                                ) {
                                                                                                                  _vm.$set(
                                                                                                                    t,
                                                                                                                    "account",
                                                                                                                    $$v
                                                                                                                  )
                                                                                                                },
                                                                                                                expression:
                                                                                                                  "t.account"
                                                                                                              }
                                                                                                            }
                                                                                                          )
                                                                                                        ],
                                                                                                        1
                                                                                                      )
                                                                                                    ],
                                                                                                    1
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "col",
                                                                                                      staticStyle: {
                                                                                                        width:
                                                                                                          "230px"
                                                                                                      }
                                                                                                    },
                                                                                                    [
                                                                                                      t.canSelectArray &&
                                                                                                      t
                                                                                                        .canSelectArray
                                                                                                        .length >
                                                                                                        1
                                                                                                        ? [
                                                                                                            _c(
                                                                                                              "el-form-item",
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "el-select",
                                                                                                                  {
                                                                                                                    staticClass:
                                                                                                                      "select",
                                                                                                                    staticStyle: {
                                                                                                                      width:
                                                                                                                        "230px"
                                                                                                                    },
                                                                                                                    attrs: {
                                                                                                                      size:
                                                                                                                        "small"
                                                                                                                    },
                                                                                                                    on: {
                                                                                                                      change: function(
                                                                                                                        $event
                                                                                                                      ) {
                                                                                                                        return _vm.handleSelectCorpAccount(
                                                                                                                          $event,
                                                                                                                          t
                                                                                                                        )
                                                                                                                      }
                                                                                                                    },
                                                                                                                    model: {
                                                                                                                      value:
                                                                                                                        t.canSelectArrayIndex,
                                                                                                                      callback: function(
                                                                                                                        $$v
                                                                                                                      ) {
                                                                                                                        _vm.$set(
                                                                                                                          t,
                                                                                                                          "canSelectArrayIndex",
                                                                                                                          $$v
                                                                                                                        )
                                                                                                                      },
                                                                                                                      expression:
                                                                                                                        "\n                                                    t.canSelectArrayIndex\n                                                  "
                                                                                                                    }
                                                                                                                  },
                                                                                                                  _vm._l(
                                                                                                                    t.canSelectArray,
                                                                                                                    function(
                                                                                                                      v2,
                                                                                                                      vi2
                                                                                                                    ) {
                                                                                                                      return _c(
                                                                                                                        "el-option",
                                                                                                                        {
                                                                                                                          key: vi2,
                                                                                                                          attrs: {
                                                                                                                            value: vi2,
                                                                                                                            label:
                                                                                                                              v2.name
                                                                                                                          }
                                                                                                                        },
                                                                                                                        [
                                                                                                                          _c(
                                                                                                                            "div",
                                                                                                                            [
                                                                                                                              v2.fromDingTalk &&
                                                                                                                              v2.fromDingTalk ===
                                                                                                                                1 &&
                                                                                                                              !_vm.isInDingTalk
                                                                                                                                ? _c(
                                                                                                                                    "img",
                                                                                                                                    {
                                                                                                                                      attrs: {
                                                                                                                                        src:
                                                                                                                                          "/images/icon/dingIcon.png",
                                                                                                                                        alt:
                                                                                                                                          "钉钉",
                                                                                                                                        width:
                                                                                                                                          "20px"
                                                                                                                                      }
                                                                                                                                    }
                                                                                                                                  )
                                                                                                                                : _vm._e(),
                                                                                                                              _c(
                                                                                                                                "span",
                                                                                                                                {
                                                                                                                                  staticStyle: {
                                                                                                                                    color:
                                                                                                                                      "#8492a6",
                                                                                                                                    "font-size":
                                                                                                                                      "13px"
                                                                                                                                  }
                                                                                                                                },
                                                                                                                                [
                                                                                                                                  _vm._v(
                                                                                                                                    _vm._s(
                                                                                                                                      v2.name
                                                                                                                                    )
                                                                                                                                  )
                                                                                                                                ]
                                                                                                                              )
                                                                                                                            ]
                                                                                                                          )
                                                                                                                        ]
                                                                                                                      )
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  1
                                                                                                                )
                                                                                                              ],
                                                                                                              1
                                                                                                            )
                                                                                                          ]
                                                                                                        : [
                                                                                                            _c(
                                                                                                              "el-form-item",
                                                                                                              {
                                                                                                                attrs: {
                                                                                                                  prop:
                                                                                                                    "name",
                                                                                                                  rules:
                                                                                                                    _vm
                                                                                                                      .rulesTab
                                                                                                                      .name,
                                                                                                                  "show-message":
                                                                                                                    t.disabled !==
                                                                                                                    "disabled"
                                                                                                                }
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "el-input",
                                                                                                                  {
                                                                                                                    staticStyle: {
                                                                                                                      width:
                                                                                                                        "230px"
                                                                                                                    },
                                                                                                                    attrs: {
                                                                                                                      disabled:
                                                                                                                        t.disabled ===
                                                                                                                        "disabled",
                                                                                                                      placeholder:
                                                                                                                        "请输入签署方名称"
                                                                                                                    },
                                                                                                                    model: {
                                                                                                                      value:
                                                                                                                        t.name,
                                                                                                                      callback: function(
                                                                                                                        $$v
                                                                                                                      ) {
                                                                                                                        _vm.$set(
                                                                                                                          t,
                                                                                                                          "name",
                                                                                                                          $$v
                                                                                                                        )
                                                                                                                      },
                                                                                                                      expression:
                                                                                                                        "t.name"
                                                                                                                    }
                                                                                                                  }
                                                                                                                )
                                                                                                              ],
                                                                                                              1
                                                                                                            )
                                                                                                          ]
                                                                                                    ],
                                                                                                    2
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "col"
                                                                                                    },
                                                                                                    [
                                                                                                      t.signatoryUserType ===
                                                                                                      0
                                                                                                        ? _c(
                                                                                                            "el-form-item",
                                                                                                            {
                                                                                                              staticStyle: {
                                                                                                                position:
                                                                                                                  "relative"
                                                                                                              },
                                                                                                              attrs: {
                                                                                                                rules:
                                                                                                                  t.disabled !==
                                                                                                                  "disabled"
                                                                                                                    ? _vm
                                                                                                                        .rulesTab
                                                                                                                        .identityNo
                                                                                                                    : {},
                                                                                                                "show-message":
                                                                                                                  t.disabled !==
                                                                                                                  "disabled",
                                                                                                                prop:
                                                                                                                  "identityNo"
                                                                                                              }
                                                                                                            },
                                                                                                            [
                                                                                                              _c(
                                                                                                                "el-input",
                                                                                                                {
                                                                                                                  class: {
                                                                                                                    "no-padding": t.disabled
                                                                                                                      ? true
                                                                                                                      : false
                                                                                                                  },
                                                                                                                  staticStyle: {
                                                                                                                    width:
                                                                                                                      "230px"
                                                                                                                  },
                                                                                                                  attrs: {
                                                                                                                    disabled:
                                                                                                                      t.disabled ===
                                                                                                                      "disabled",
                                                                                                                    placeholder:
                                                                                                                      "请输入中国大陆18位身份证号码"
                                                                                                                  },
                                                                                                                  model: {
                                                                                                                    value:
                                                                                                                      t.identityNo,
                                                                                                                    callback: function(
                                                                                                                      $$v
                                                                                                                    ) {
                                                                                                                      _vm.$set(
                                                                                                                        t,
                                                                                                                        "identityNo",
                                                                                                                        $$v
                                                                                                                      )
                                                                                                                    },
                                                                                                                    expression:
                                                                                                                      "t.identityNo"
                                                                                                                  }
                                                                                                                }
                                                                                                              )
                                                                                                            ],
                                                                                                            1
                                                                                                          )
                                                                                                        : _vm._e(),
                                                                                                      t.signatoryUserType ===
                                                                                                      1
                                                                                                        ? _c(
                                                                                                            "el-form-item",
                                                                                                            {
                                                                                                              staticStyle: {
                                                                                                                position:
                                                                                                                  "relative"
                                                                                                              },
                                                                                                              attrs: {
                                                                                                                prop:
                                                                                                                  "identityNo",
                                                                                                                rules:
                                                                                                                  t.disabled !==
                                                                                                                  "disabled"
                                                                                                                    ? _vm
                                                                                                                        .rulesTab
                                                                                                                        .businessLicense
                                                                                                                    : {}
                                                                                                              }
                                                                                                            },
                                                                                                            [
                                                                                                              _c(
                                                                                                                "el-input",
                                                                                                                {
                                                                                                                  class: {
                                                                                                                    "no-padding": t.disabled
                                                                                                                      ? true
                                                                                                                      : false
                                                                                                                  },
                                                                                                                  staticStyle: {
                                                                                                                    width:
                                                                                                                      "230px"
                                                                                                                  },
                                                                                                                  attrs: {
                                                                                                                    disabled:
                                                                                                                      t.disabled ===
                                                                                                                      "disabled",
                                                                                                                    placeholder:
                                                                                                                      "请输入统一社会编码"
                                                                                                                  },
                                                                                                                  model: {
                                                                                                                    value:
                                                                                                                      t.identityNo,
                                                                                                                    callback: function(
                                                                                                                      $$v
                                                                                                                    ) {
                                                                                                                      _vm.$set(
                                                                                                                        t,
                                                                                                                        "identityNo",
                                                                                                                        $$v
                                                                                                                      )
                                                                                                                    },
                                                                                                                    expression:
                                                                                                                      "t.identityNo"
                                                                                                                  }
                                                                                                                }
                                                                                                              )
                                                                                                            ],
                                                                                                            1
                                                                                                          )
                                                                                                        : _vm._e()
                                                                                                    ],
                                                                                                    1
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "col",
                                                                                                      staticStyle: {
                                                                                                        width:
                                                                                                          "150px"
                                                                                                      }
                                                                                                    },
                                                                                                    [
                                                                                                      t.isNoticePhone &&
                                                                                                      !t.showNoticePhone
                                                                                                        ? _c(
                                                                                                            "el-button",
                                                                                                            {
                                                                                                              attrs: {
                                                                                                                icon:
                                                                                                                  "el-icon-plus"
                                                                                                              },
                                                                                                              on: {
                                                                                                                click: function(
                                                                                                                  $event
                                                                                                                ) {
                                                                                                                  return _vm.changBatchUserShowNoticePhone(
                                                                                                                    m
                                                                                                                  )
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          )
                                                                                                        : _vm._e(),
                                                                                                      t.signatoryUserType ===
                                                                                                        1 &&
                                                                                                      t.showNoticePhone
                                                                                                        ? _c(
                                                                                                            "el-form-item",
                                                                                                            {
                                                                                                              attrs: {
                                                                                                                rules:
                                                                                                                  _vm
                                                                                                                    .rulesTab
                                                                                                                    .mobile
                                                                                                              }
                                                                                                            },
                                                                                                            [
                                                                                                              _c(
                                                                                                                "el-input",
                                                                                                                {
                                                                                                                  attrs: {
                                                                                                                    placeholder:
                                                                                                                      "请输入通知手机号"
                                                                                                                  },
                                                                                                                  model: {
                                                                                                                    value:
                                                                                                                      t.mobile,
                                                                                                                    callback: function(
                                                                                                                      $$v
                                                                                                                    ) {
                                                                                                                      _vm.$set(
                                                                                                                        t,
                                                                                                                        "mobile",
                                                                                                                        $$v
                                                                                                                      )
                                                                                                                    },
                                                                                                                    expression:
                                                                                                                      "t.mobile"
                                                                                                                  }
                                                                                                                }
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "span",
                                                                                                                {
                                                                                                                  staticClass:
                                                                                                                    "g-icon-close",
                                                                                                                  on: {
                                                                                                                    click: function(
                                                                                                                      $event
                                                                                                                    ) {
                                                                                                                      return _vm.changBatchUserShowNoticePhone(
                                                                                                                        m
                                                                                                                      )
                                                                                                                    }
                                                                                                                  }
                                                                                                                },
                                                                                                                [
                                                                                                                  _c(
                                                                                                                    "i",
                                                                                                                    {
                                                                                                                      staticClass:
                                                                                                                        "el-icon-error"
                                                                                                                    }
                                                                                                                  )
                                                                                                                ]
                                                                                                              )
                                                                                                            ],
                                                                                                            1
                                                                                                          )
                                                                                                        : _vm._e()
                                                                                                    ],
                                                                                                    1
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "col",
                                                                                                  staticStyle: {
                                                                                                    flex:
                                                                                                      "none"
                                                                                                  },
                                                                                                  attrs: {
                                                                                                    span:
                                                                                                      t.signatoryUserType ===
                                                                                                      0
                                                                                                        ? 3
                                                                                                        : 7
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "el-form-item",
                                                                                                    {
                                                                                                      staticStyle: {
                                                                                                        "text-align":
                                                                                                          "right",
                                                                                                        "line-height":
                                                                                                          "50px"
                                                                                                      }
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "el-button",
                                                                                                        {
                                                                                                          on: {
                                                                                                            click: function(
                                                                                                              $event
                                                                                                            ) {
                                                                                                              return _vm.batchClear(
                                                                                                                m
                                                                                                              )
                                                                                                            }
                                                                                                          }
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "删除"
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ],
                                                                                                    1
                                                                                                  )
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  }
                                                                                )
                                                                              ],
                                                                              2
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        key: i
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-form",
                                                                          {
                                                                            key: i,
                                                                            ref:
                                                                              "contractListTab",
                                                                            refInFor: true,
                                                                            staticClass:
                                                                              "contract-lit__tab",
                                                                            attrs: {
                                                                              model: item,
                                                                              size:
                                                                                "small",
                                                                              "data-signOwner":
                                                                                item.signOwner
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                class: {
                                                                                  item: true,
                                                                                  "sign-item": true,
                                                                                  "i-drag":
                                                                                    _vm
                                                                                      .contractInfo
                                                                                      .ifOrder
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              _vm
                                                                                                .contractInfo
                                                                                                .ifOrder,
                                                                                            expression:
                                                                                              "contractInfo.ifOrder"
                                                                                          }
                                                                                        ],
                                                                                        staticClass:
                                                                                          "icon-move_box"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              _vm
                                                                                                .contractInfo
                                                                                                .ifOrder,
                                                                                            expression:
                                                                                              "contractInfo.ifOrder"
                                                                                          }
                                                                                        ],
                                                                                        staticStyle: {
                                                                                          width:
                                                                                            "26px",
                                                                                          "text-align":
                                                                                            "right"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            i +
                                                                                              1
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "user-type"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "p",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "签署方"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col",
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "110px"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "el-form-item",
                                                                                      [
                                                                                        _c(
                                                                                          "el-select",
                                                                                          {
                                                                                            staticClass:
                                                                                              "select",
                                                                                            staticStyle: {
                                                                                              width:
                                                                                                "110px"
                                                                                            },
                                                                                            attrs: {
                                                                                              size:
                                                                                                "small"
                                                                                            },
                                                                                            on: {
                                                                                              change: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.handleSignUserType(
                                                                                                  item,
                                                                                                  i
                                                                                                )
                                                                                              }
                                                                                            },
                                                                                            model: {
                                                                                              value:
                                                                                                item.signatoryUserType,
                                                                                              callback: function(
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.$set(
                                                                                                  item,
                                                                                                  "signatoryUserType",
                                                                                                  $$v
                                                                                                )
                                                                                              },
                                                                                              expression:
                                                                                                "item.signatoryUserType"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "el-option",
                                                                                              {
                                                                                                attrs: {
                                                                                                  value: 0,
                                                                                                  label:
                                                                                                    "个人"
                                                                                                }
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              "el-option",
                                                                                              {
                                                                                                attrs: {
                                                                                                  value: 1,
                                                                                                  label:
                                                                                                    "企业"
                                                                                                }
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              "el-option",
                                                                                              {
                                                                                                directives: [
                                                                                                  {
                                                                                                    name:
                                                                                                      "show",
                                                                                                    rawName:
                                                                                                      "v-show",
                                                                                                    value:
                                                                                                      _vm.activeTabsName ===
                                                                                                      _vm
                                                                                                        .signTypes[0],
                                                                                                    expression:
                                                                                                      "activeTabsName === signTypes[0]"
                                                                                                  }
                                                                                                ],
                                                                                                attrs: {
                                                                                                  value: 2,
                                                                                                  label:
                                                                                                    "港澳台个人"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col",
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "230px"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    [
                                                                                      0,
                                                                                      1
                                                                                    ].includes(
                                                                                      item.signatoryUserType
                                                                                    )
                                                                                      ? [
                                                                                          _c(
                                                                                            "el-form-item",
                                                                                            {
                                                                                              attrs: {
                                                                                                prop:
                                                                                                  "account",
                                                                                                rules: [
                                                                                                  1,
                                                                                                  2
                                                                                                ].includes(
                                                                                                  item.signatoryUserType
                                                                                                )
                                                                                                  ? _vm
                                                                                                      .rulesTab
                                                                                                      .account
                                                                                                  : _vm
                                                                                                      .rulesTab
                                                                                                      .mobile
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "el-input",
                                                                                                {
                                                                                                  staticStyle: {
                                                                                                    width:
                                                                                                      "230px"
                                                                                                  },
                                                                                                  attrs: {
                                                                                                    placeholder:
                                                                                                      "签署方接收通知的" +
                                                                                                      (item.signatoryUserType ==
                                                                                                      1
                                                                                                        ? "手机/邮箱"
                                                                                                        : item.signatoryUserType ==
                                                                                                          2
                                                                                                        ? "邮箱"
                                                                                                        : "手机号")
                                                                                                  },
                                                                                                  on: {
                                                                                                    blur: function() {
                                                                                                      ;(item.account = _vm.$utils.trim(
                                                                                                        item.account
                                                                                                      )),
                                                                                                        (item.corpUser =
                                                                                                          ""),
                                                                                                        _vm.getUserInfoBySelectTargetId(
                                                                                                          {
                                                                                                            account:
                                                                                                              item.account,
                                                                                                            selectIndex: i,
                                                                                                            type: false
                                                                                                          }
                                                                                                        )
                                                                                                    }
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      item.account,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        item,
                                                                                                        "account",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "item.account"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "i",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "icon icon-btn_tels",
                                                                                                      staticStyle: {
                                                                                                        "background-size":
                                                                                                          "contain",
                                                                                                        cursor:
                                                                                                          "pointer"
                                                                                                      },
                                                                                                      attrs: {
                                                                                                        slot:
                                                                                                          "suffix"
                                                                                                      },
                                                                                                      on: {
                                                                                                        click: function(
                                                                                                          $event
                                                                                                        ) {
                                                                                                          return _vm.handleTelsClickOther(
                                                                                                            item,
                                                                                                            i
                                                                                                          )
                                                                                                        }
                                                                                                      },
                                                                                                      slot:
                                                                                                        "suffix"
                                                                                                    }
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                      : [
                                                                                          _c(
                                                                                            "el-form-item",
                                                                                            {
                                                                                              attrs: {
                                                                                                prop:
                                                                                                  "account",
                                                                                                rules:
                                                                                                  _vm
                                                                                                    .rulesTab
                                                                                                    .email
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "el-input",
                                                                                                {
                                                                                                  staticStyle: {
                                                                                                    width:
                                                                                                      "230px"
                                                                                                  },
                                                                                                  attrs: {
                                                                                                    placeholder:
                                                                                                      "签署方接收通知的邮箱"
                                                                                                  },
                                                                                                  on: {
                                                                                                    blur: function() {
                                                                                                      ;(item.account = _vm.$utils.trim(
                                                                                                        item.account
                                                                                                      )),
                                                                                                        (item.corpUser =
                                                                                                          ""),
                                                                                                        _vm.getUserInfoBySelectTargetId(
                                                                                                          {
                                                                                                            account:
                                                                                                              item.account,
                                                                                                            selectIndex: i,
                                                                                                            type: false
                                                                                                          }
                                                                                                        )
                                                                                                    }
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      item.account,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        item,
                                                                                                        "account",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "item.account"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "i",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "icon icon-btn_tels",
                                                                                                      staticStyle: {
                                                                                                        "background-size":
                                                                                                          "contain",
                                                                                                        cursor:
                                                                                                          "pointer"
                                                                                                      },
                                                                                                      attrs: {
                                                                                                        slot:
                                                                                                          "suffix"
                                                                                                      },
                                                                                                      on: {
                                                                                                        click: function(
                                                                                                          $event
                                                                                                        ) {
                                                                                                          return _vm.handleTelsClickOther(
                                                                                                            item,
                                                                                                            i
                                                                                                          )
                                                                                                        }
                                                                                                      },
                                                                                                      slot:
                                                                                                        "suffix"
                                                                                                    }
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                  ],
                                                                                  2
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col",
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "230px"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    item.canSelectArray &&
                                                                                    ((+item.signatoryUserType ===
                                                                                      1 &&
                                                                                      item
                                                                                        .canSelectArray
                                                                                        .length >
                                                                                        0 &&
                                                                                      !item.ManualInput) ||
                                                                                      (+item.signatoryUserType ===
                                                                                        0 &&
                                                                                        item
                                                                                          .canSelectArray
                                                                                          .length >
                                                                                          1))
                                                                                      ? [
                                                                                          _c(
                                                                                            "el-form-item",
                                                                                            [
                                                                                              _c(
                                                                                                "el-select",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "select",
                                                                                                  staticStyle: {
                                                                                                    width:
                                                                                                      "230px"
                                                                                                  },
                                                                                                  attrs: {
                                                                                                    size:
                                                                                                      "small"
                                                                                                  },
                                                                                                  on: {
                                                                                                    change: function(
                                                                                                      $event
                                                                                                    ) {
                                                                                                      return _vm.handleSelectCorpAccount(
                                                                                                        $event,
                                                                                                        item
                                                                                                      )
                                                                                                    }
                                                                                                  },
                                                                                                  model: {
                                                                                                    value:
                                                                                                      item.canSelectArrayIndex,
                                                                                                    callback: function(
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        item,
                                                                                                        "canSelectArrayIndex",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                    expression:
                                                                                                      "item.canSelectArrayIndex"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._l(
                                                                                                    item.canSelectArray,
                                                                                                    function(
                                                                                                      v,
                                                                                                      vi
                                                                                                    ) {
                                                                                                      return _c(
                                                                                                        "el-option",
                                                                                                        {
                                                                                                          key: vi,
                                                                                                          attrs: {
                                                                                                            value: vi,
                                                                                                            label:
                                                                                                              v.name
                                                                                                          }
                                                                                                        },
                                                                                                        [
                                                                                                          _c(
                                                                                                            "div",
                                                                                                            [
                                                                                                              v.fromDingTalk &&
                                                                                                              v.fromDingTalk ===
                                                                                                                1 &&
                                                                                                              !_vm.isInDingTalk
                                                                                                                ? _c(
                                                                                                                    "img",
                                                                                                                    {
                                                                                                                      attrs: {
                                                                                                                        src:
                                                                                                                          "/images/icon/dingIcon.png",
                                                                                                                        alt:
                                                                                                                          "钉钉",
                                                                                                                        width:
                                                                                                                          "20px"
                                                                                                                      }
                                                                                                                    }
                                                                                                                  )
                                                                                                                : _vm._e(),
                                                                                                              _c(
                                                                                                                "span",
                                                                                                                {
                                                                                                                  staticStyle: {
                                                                                                                    color:
                                                                                                                      "#8492a6",
                                                                                                                    "font-size":
                                                                                                                      "13px"
                                                                                                                  }
                                                                                                                },
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      v.name
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    }
                                                                                                  ),
                                                                                                  item.signatoryUserType ===
                                                                                                  1
                                                                                                    ? _c(
                                                                                                        "el-option",
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            value:
                                                                                                              "ManualInput",
                                                                                                            label:
                                                                                                              "手动输入"
                                                                                                          }
                                                                                                        }
                                                                                                      )
                                                                                                    : _vm._e()
                                                                                                ],
                                                                                                2
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                      : [
                                                                                          _c(
                                                                                            "el-form-item",
                                                                                            {
                                                                                              attrs: {
                                                                                                prop:
                                                                                                  "name",
                                                                                                rules:
                                                                                                  _vm
                                                                                                    .rulesTab
                                                                                                    .name,
                                                                                                "show-message":
                                                                                                  item.disabled !==
                                                                                                  "disabled"
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "el-input",
                                                                                                {
                                                                                                  staticStyle: {
                                                                                                    width:
                                                                                                      "230px"
                                                                                                  },
                                                                                                  attrs: {
                                                                                                    value:
                                                                                                      item.name,
                                                                                                    disabled:
                                                                                                      item.disabled ===
                                                                                                      "disabled",
                                                                                                    placeholder: [
                                                                                                      0,
                                                                                                      2
                                                                                                    ].includes(
                                                                                                      item.signatoryUserType
                                                                                                    )
                                                                                                      ? "请输入签署方姓名"
                                                                                                      : "请输入签署方公司名称"
                                                                                                  },
                                                                                                  on: {
                                                                                                    input: function(
                                                                                                      val
                                                                                                    ) {
                                                                                                      item.name = val.trim()
                                                                                                      _vm.changeQSNameInQZ(
                                                                                                        item.signOwner,
                                                                                                        val
                                                                                                      )
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                  ],
                                                                                  2
                                                                                ),
                                                                                item.signatoryUserType ===
                                                                                0
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "col",
                                                                                        staticStyle: {
                                                                                          width:
                                                                                            "190px"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              display:
                                                                                                "flex",
                                                                                              "justify-content":
                                                                                                "flex-start",
                                                                                              "align-items":
                                                                                                "center"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            item.signatoryUserType ===
                                                                                              0 &&
                                                                                            !item.idCardNoShow
                                                                                              ? _c(
                                                                                                  "el-button",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      margin:
                                                                                                        "0"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      icon:
                                                                                                        "el-icon-plus"
                                                                                                    },
                                                                                                    on: {
                                                                                                      click: function(
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.idCardNoShowFn(
                                                                                                          item
                                                                                                        )
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            item.signatoryUserType ===
                                                                                              0 &&
                                                                                            item.idCardNoShow
                                                                                              ? _c(
                                                                                                  "el-form-item",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      position:
                                                                                                        "relative"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      rules:
                                                                                                        item.disabled !==
                                                                                                        "disabled"
                                                                                                          ? _vm
                                                                                                              .rulesTab
                                                                                                              .identityNo
                                                                                                          : {},
                                                                                                      "show-message":
                                                                                                        item.disabled !==
                                                                                                        "disabled"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "el-input",
                                                                                                      {
                                                                                                        class: {
                                                                                                          "no-padding": item.disabled
                                                                                                            ? true
                                                                                                            : false
                                                                                                        },
                                                                                                        staticStyle: {
                                                                                                          width:
                                                                                                            "230px"
                                                                                                        },
                                                                                                        attrs: {
                                                                                                          disabled:
                                                                                                            item.disabled ===
                                                                                                            "disabled",
                                                                                                          placeholder:
                                                                                                            "请输入中国大陆18位身份证号码"
                                                                                                        },
                                                                                                        model: {
                                                                                                          value:
                                                                                                            item.identityNo,
                                                                                                          callback: function(
                                                                                                            $$v
                                                                                                          ) {
                                                                                                            _vm.$set(
                                                                                                              item,
                                                                                                              "identityNo",
                                                                                                              $$v
                                                                                                            )
                                                                                                          },
                                                                                                          expression:
                                                                                                            "item.identityNo"
                                                                                                        }
                                                                                                      }
                                                                                                    ),
                                                                                                    item.ischange ===
                                                                                                    1
                                                                                                      ? _c(
                                                                                                          "a",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "color-success amend-signator amend-tab__form",
                                                                                                            staticStyle: {
                                                                                                              right:
                                                                                                                "13px",
                                                                                                              "font-size":
                                                                                                                "12px"
                                                                                                            },
                                                                                                            attrs: {
                                                                                                              href:
                                                                                                                "javascript:void (0)"
                                                                                                            }
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "已实名"
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      : _vm._e()
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                item.signatoryUserType ===
                                                                                1
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "col",
                                                                                        staticStyle: {
                                                                                          width:
                                                                                            "190px"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm.isShow(
                                                                                          "btn",
                                                                                          item
                                                                                        )
                                                                                          ? _c(
                                                                                              "el-button",
                                                                                              {
                                                                                                attrs: {
                                                                                                  icon:
                                                                                                    "el-icon-plus"
                                                                                                },
                                                                                                on: {
                                                                                                  click: function(
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.changShowNoticePhone(
                                                                                                      i
                                                                                                    )
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          : _vm._e(),
                                                                                        _vm.isShow(
                                                                                          "input",
                                                                                          item
                                                                                        )
                                                                                          ? _c(
                                                                                              "el-form-item",
                                                                                              {
                                                                                                attrs: {
                                                                                                  rules:
                                                                                                    _vm
                                                                                                      .rulesTab
                                                                                                      .mobile
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "el-input",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      width:
                                                                                                        "230px"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      placeholder:
                                                                                                        "请输入通知手机号"
                                                                                                    },
                                                                                                    model: {
                                                                                                      value:
                                                                                                        item.mobile,
                                                                                                      callback: function(
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          item,
                                                                                                          "mobile",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                      expression:
                                                                                                        "item.mobile"
                                                                                                    }
                                                                                                  }
                                                                                                ),
                                                                                                _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    directives: [
                                                                                                      {
                                                                                                        name:
                                                                                                          "show",
                                                                                                        rawName:
                                                                                                          "v-show",
                                                                                                        value:
                                                                                                          _vm.activeTabsName ==
                                                                                                            _vm
                                                                                                              .signTypes[1] &&
                                                                                                          !_vm.happy.email.test(
                                                                                                            item.account
                                                                                                          ),
                                                                                                        expression:
                                                                                                          "\n                                          activeTabsName == signTypes[1] &&\n                                          !happy.email.test(item.account)\n                                        "
                                                                                                      }
                                                                                                    ],
                                                                                                    staticClass:
                                                                                                      "g-icon-close",
                                                                                                    on: {
                                                                                                      click: function(
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.changShowNoticePhone(
                                                                                                          i
                                                                                                        )
                                                                                                      }
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "i",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "el-icon-error"
                                                                                                      }
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          : _vm._e()
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _vm._e(),
                                                                                item.signatoryUserType ===
                                                                                2
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "col",
                                                                                        staticStyle: {
                                                                                          width:
                                                                                            "190px"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "el-form-item",
                                                                                          {
                                                                                            attrs: {
                                                                                              prop:
                                                                                                "identityNo",
                                                                                              rules:
                                                                                                _vm
                                                                                                  .rulesTab
                                                                                                  .identityNo
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "el-input",
                                                                                              {
                                                                                                staticStyle: {
                                                                                                  width:
                                                                                                    "230px"
                                                                                                },
                                                                                                attrs: {
                                                                                                  maxlength: 50,
                                                                                                  placeholder:
                                                                                                    "请输入签署方证件号码"
                                                                                                },
                                                                                                model: {
                                                                                                  value:
                                                                                                    item.identityNo,
                                                                                                  callback: function(
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      item,
                                                                                                      "identityNo",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                  expression:
                                                                                                    "item.identityNo"
                                                                                                }
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              "el-tooltip",
                                                                                              {
                                                                                                attrs: {
                                                                                                  effect:
                                                                                                    "dark",
                                                                                                  content:
                                                                                                    "仅支持港澳居民来往内地通行证、台湾居民来往内地通行证及护照，发起时请与签约方确认好证件类型及号码。",
                                                                                                  placement:
                                                                                                    "top"
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "i",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "el-icon-question",
                                                                                                    staticStyle: {
                                                                                                      "font-size":
                                                                                                        "20px",
                                                                                                      "margin-left":
                                                                                                        "10px",
                                                                                                      color:
                                                                                                        "#a1a1a1"
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col",
                                                                                    staticStyle: {
                                                                                      "padding-right":
                                                                                        "0",
                                                                                      "margin-right":
                                                                                        "6px"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "check-box"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "el-checkbox-button",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              position:
                                                                                                "relative",
                                                                                              "margin-right":
                                                                                                "20px"
                                                                                            },
                                                                                            attrs: {
                                                                                              value: !!item.needRead
                                                                                            },
                                                                                            on: {
                                                                                              change: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.checkChange(
                                                                                                  $event,
                                                                                                  item,
                                                                                                  i
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "\n                                          强制阅读\n                                          "
                                                                                            ),
                                                                                            item.needRead
                                                                                              ? _c(
                                                                                                  "img",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "check-act",
                                                                                                    attrs: {
                                                                                                      src:
                                                                                                        "/images/selected.png",
                                                                                                      alt:
                                                                                                        ""
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ]
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                    item.signatoryUserType !==
                                                                                    2
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "check-box"
                                                                                          },
                                                                                          [
                                                                                            _vm.activeTabsName ===
                                                                                            _vm
                                                                                              .signTypes[0]
                                                                                              ? _c(
                                                                                                  "el-checkbox-button",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      "margin-right":
                                                                                                        "20px",
                                                                                                      position:
                                                                                                        "relative"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      "true-label": 11,
                                                                                                      "false-label": null,
                                                                                                      checked:
                                                                                                        item.signatoryUserType ===
                                                                                                          0 &&
                                                                                                        _vm.activeTabsName ===
                                                                                                          _vm
                                                                                                            .signTypes[0] &&
                                                                                                        item.authLevel ==
                                                                                                          11
                                                                                                    },
                                                                                                    model: {
                                                                                                      value:
                                                                                                        item.authLevel,
                                                                                                      callback: function(
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          item,
                                                                                                          "authLevel",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                      expression:
                                                                                                        "item.authLevel"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "\n                                          人脸识别\n                                          "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "img",
                                                                                                      {
                                                                                                        directives: [
                                                                                                          {
                                                                                                            name:
                                                                                                              "show",
                                                                                                            rawName:
                                                                                                              "v-show",
                                                                                                            value:
                                                                                                              item.authLevel ==
                                                                                                              11,
                                                                                                            expression:
                                                                                                              "item.authLevel == 11"
                                                                                                          }
                                                                                                        ],
                                                                                                        staticClass:
                                                                                                          "check-act",
                                                                                                        attrs: {
                                                                                                          src:
                                                                                                            "/images/selected.png",
                                                                                                          alt:
                                                                                                            ""
                                                                                                        }
                                                                                                      }
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    item.signatoryUserType ==
                                                                                    0
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "check-box"
                                                                                          },
                                                                                          [
                                                                                            _vm.activeTabsName ===
                                                                                            _vm
                                                                                              .signTypes[0]
                                                                                              ? _c(
                                                                                                  "el-checkbox-button",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      "margin-right":
                                                                                                        "20px",
                                                                                                      position:
                                                                                                        "relative"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      "true-label": 12,
                                                                                                      "false-label": null
                                                                                                    },
                                                                                                    model: {
                                                                                                      value:
                                                                                                        item.authLevel,
                                                                                                      callback: function(
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          item,
                                                                                                          "authLevel",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                      expression:
                                                                                                        "item.authLevel"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "\n                                          短信验证\n                                          "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "img",
                                                                                                      {
                                                                                                        directives: [
                                                                                                          {
                                                                                                            name:
                                                                                                              "show",
                                                                                                            rawName:
                                                                                                              "v-show",
                                                                                                            value:
                                                                                                              item.authLevel ==
                                                                                                              12,
                                                                                                            expression:
                                                                                                              "item.authLevel == 12"
                                                                                                          }
                                                                                                        ],
                                                                                                        staticClass:
                                                                                                          "check-act",
                                                                                                        attrs: {
                                                                                                          src:
                                                                                                            "/images/selected.png",
                                                                                                          alt:
                                                                                                            ""
                                                                                                        }
                                                                                                      }
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    item.signatoryUserType ==
                                                                                    1
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "check-box"
                                                                                          },
                                                                                          [
                                                                                            _vm.activeTabsName ===
                                                                                            _vm
                                                                                              .signTypes[0]
                                                                                              ? _c(
                                                                                                  "el-checkbox-button",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      "margin-right":
                                                                                                        "20px",
                                                                                                      position:
                                                                                                        "relative"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      "true-label": 1,
                                                                                                      "false-label": null
                                                                                                    },
                                                                                                    model: {
                                                                                                      value:
                                                                                                        item.extraHandSign,
                                                                                                      callback: function(
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          item,
                                                                                                          "extraHandSign",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                      expression:
                                                                                                        "item.extraHandSign"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "\n                                          经办人签字\n                                          "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "img",
                                                                                                      {
                                                                                                        directives: [
                                                                                                          {
                                                                                                            name:
                                                                                                              "show",
                                                                                                            rawName:
                                                                                                              "v-show",
                                                                                                            value:
                                                                                                              item.extraHandSign ==
                                                                                                              1,
                                                                                                            expression:
                                                                                                              "item.extraHandSign == 1"
                                                                                                          }
                                                                                                        ],
                                                                                                        staticClass:
                                                                                                          "check-act",
                                                                                                        attrs: {
                                                                                                          src:
                                                                                                            "/images/selected.png",
                                                                                                          alt:
                                                                                                            ""
                                                                                                        }
                                                                                                      }
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm.activeTabsName ===
                                                                                    _vm
                                                                                      .signTypes[1]
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "check-box"
                                                                                          },
                                                                                          [
                                                                                            _vm.activeTabsName ===
                                                                                            _vm
                                                                                              .signTypes[1]
                                                                                              ? _c(
                                                                                                  "el-tooltip",
                                                                                                  {
                                                                                                    attrs: {
                                                                                                      effect:
                                                                                                        "light",
                                                                                                      placement:
                                                                                                        "top",
                                                                                                      content:
                                                                                                        "选中需参与视频通话，最多同时支持四人参加视频通话。"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "el-checkbox-button",
                                                                                                      {
                                                                                                        staticStyle: {
                                                                                                          position:
                                                                                                            "relative",
                                                                                                          "margin-right":
                                                                                                            "20px"
                                                                                                        },
                                                                                                        attrs: {
                                                                                                          border:
                                                                                                            "",
                                                                                                          "true-label": 1,
                                                                                                          disabled: _vm.disOption(
                                                                                                            item
                                                                                                          ),
                                                                                                          checked:
                                                                                                            item.faceOrVideo ==
                                                                                                            1
                                                                                                        },
                                                                                                        on: {
                                                                                                          change: function(
                                                                                                            $event
                                                                                                          ) {
                                                                                                            return _vm.videoPartIn(
                                                                                                              $event,
                                                                                                              item
                                                                                                            )
                                                                                                          }
                                                                                                        },
                                                                                                        model: {
                                                                                                          value:
                                                                                                            item.faceOrVideo,
                                                                                                          callback: function(
                                                                                                            $$v
                                                                                                          ) {
                                                                                                            _vm.$set(
                                                                                                              item,
                                                                                                              "faceOrVideo",
                                                                                                              $$v
                                                                                                            )
                                                                                                          },
                                                                                                          expression:
                                                                                                            "item.faceOrVideo"
                                                                                                        }
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "span",
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "视频通话"
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "img",
                                                                                                          {
                                                                                                            directives: [
                                                                                                              {
                                                                                                                name:
                                                                                                                  "show",
                                                                                                                rawName:
                                                                                                                  "v-show",
                                                                                                                value:
                                                                                                                  item.faceOrVideo ==
                                                                                                                  1,
                                                                                                                expression:
                                                                                                                  "item.faceOrVideo == 1"
                                                                                                              }
                                                                                                            ],
                                                                                                            staticClass:
                                                                                                              "check-act",
                                                                                                            attrs: {
                                                                                                              src:
                                                                                                                "/images/selected.png",
                                                                                                              alt:
                                                                                                                ""
                                                                                                            }
                                                                                                          }
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm.activeTabsName ===
                                                                                    _vm
                                                                                      .signTypes[2]
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "check-box"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "el-checkbox-button",
                                                                                              {
                                                                                                staticStyle: {
                                                                                                  "margin-right":
                                                                                                    "20px",
                                                                                                  position:
                                                                                                    "relative"
                                                                                                },
                                                                                                attrs: {
                                                                                                  checked:
                                                                                                    item.accessCode
                                                                                                },
                                                                                                on: {
                                                                                                  change: function(
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.checkCodeChange(
                                                                                                      $event,
                                                                                                      item,
                                                                                                      i
                                                                                                    )
                                                                                                  }
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                          校验码\n                                          "
                                                                                                ),
                                                                                                _c(
                                                                                                  "img",
                                                                                                  {
                                                                                                    directives: [
                                                                                                      {
                                                                                                        name:
                                                                                                          "show",
                                                                                                        rawName:
                                                                                                          "v-show",
                                                                                                        value:
                                                                                                          item.accessCode,
                                                                                                        expression:
                                                                                                          "item.accessCode"
                                                                                                      }
                                                                                                    ],
                                                                                                    staticClass:
                                                                                                      "check-act",
                                                                                                    attrs: {
                                                                                                      src:
                                                                                                        "/images/selected.png",
                                                                                                      alt:
                                                                                                        ""
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _c(
                                                                                      "p",
                                                                                      {
                                                                                        staticStyle: {
                                                                                          display:
                                                                                            "inline-block",
                                                                                          width:
                                                                                            "16px",
                                                                                          "margin-left":
                                                                                            "23px"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            directives: [
                                                                                              {
                                                                                                name:
                                                                                                  "show",
                                                                                                rawName:
                                                                                                  "v-show",
                                                                                                value:
                                                                                                  _vm
                                                                                                    .signatoryJson
                                                                                                    .length >
                                                                                                  1,
                                                                                                expression:
                                                                                                  "signatoryJson.length > 1"
                                                                                              }
                                                                                            ],
                                                                                            staticClass:
                                                                                              "el-icon-delete",
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.delSignList(
                                                                                                  item
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                              ]
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-dialog",
                                            {
                                              attrs: {
                                                title: "提示",
                                                visible: _vm.authLevelShow,
                                                width: "20%"
                                              },
                                              on: {
                                                "update:visible": function(
                                                  $event
                                                ) {
                                                  _vm.authLevelShow = $event
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-block",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "是否取消该签署方的人脸识别？取消人脸识别，将不能把该签署方的人脸视频文件作为签署证据。"
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "dialog-footer",
                                                  attrs: { slot: "footer" },
                                                  slot: "footer"
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.authLevelShow = false
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("取 消")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.dialogVisible = false
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("确 定")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.activeTabsName ==
                                          _vm.signTypes[1],
                                        expression:
                                          "activeTabsName == signTypes[1]"
                                      }
                                    ],
                                    staticClass: "card",
                                    staticStyle: { "margin-bottom": "10px" }
                                  },
                                  [
                                    _c("div", { staticClass: "card-tit" }, [
                                      _c("i"),
                                      _vm._v("视频通话设置\n                  ")
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "card-box",
                                        staticStyle: { "padding-bottom": "0" }
                                      },
                                      [
                                        _c(
                                          "el-form",
                                          { attrs: { inline: true } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticStyle: {
                                                  "margin-right": "35px"
                                                },
                                                attrs: {
                                                  label: "视频通话主持人"
                                                }
                                              },
                                              [
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "light",
                                                        placement: "top",
                                                        content:
                                                          "仅主持人可以发起/结束视频通话。"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-question",
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                          cursor: "pointer",
                                                          margin:
                                                            "0 10px 0 1px",
                                                          color: "#a1a1a1"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "请选择视频通话主持人"
                                                      },
                                                      on: {
                                                        change: _vm.hostChange
                                                      },
                                                      model: {
                                                        value: _vm.videoAnchor,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.videoAnchor = $$v
                                                        },
                                                        expression:
                                                          "videoAnchor"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.signerList,
                                                      function(signer, i) {
                                                        return _c("el-option", {
                                                          key: i,
                                                          attrs: {
                                                            label: signer.name,
                                                            value:
                                                              signer.signOwner
                                                          }
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ]
                                              ],
                                              2
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                staticStyle: {
                                                  "margin-right": "35px"
                                                },
                                                attrs: { label: "通话时长" }
                                              },
                                              [_c("p", [_vm._v("5分钟")])]
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                staticStyle: {
                                                  "margin-right": "35px"
                                                },
                                                attrs: { label: "开始时间" }
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "start-time",
                                                  staticStyle: {
                                                    width: "207px"
                                                  },
                                                  attrs: {
                                                    type: "datetime",
                                                    format:
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    "picker-options":
                                                      _vm.videoPickerOptions,
                                                    clearable: _vm.clearable,
                                                    placeholder: "选择日期"
                                                  },
                                                  on: { change: _vm.pickTime },
                                                  model: {
                                                    value:
                                                      _vm.contractInfo
                                                        .videoSignStartTime,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.contractInfo,
                                                        "videoSignStartTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "contractInfo.videoSignStartTime"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                !_vm.checkedBatch
                                  ? _c(
                                      "div",
                                      { staticClass: "f-center2" },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _vm.isInDingTalk
                                              ? _c(
                                                  "el-tabs",
                                                  {
                                                    attrs: { stretch: true },
                                                    model: {
                                                      value: _vm.flowType,
                                                      callback: function($$v) {
                                                        _vm.flowType = $$v
                                                      },
                                                      expression: "flowType"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-tab-pane",
                                                      {
                                                        staticStyle: {
                                                          padding: "20px"
                                                        },
                                                        attrs: {
                                                          label: "选择审批流程",
                                                          name: _vm.flowTypes[0]
                                                        }
                                                      },
                                                      [
                                                        _c("flow-path", {
                                                          on: {
                                                            flowSelectChange:
                                                              _vm.flowSelectChange
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-tab-pane",
                                                      {
                                                        staticStyle: {
                                                          padding: "20px"
                                                        },
                                                        attrs: {
                                                          label:
                                                            "自主选择审批人",
                                                          name: _vm.flowTypes[1]
                                                        }
                                                      },
                                                      [
                                                        _c("self-selection", {
                                                          attrs: {
                                                            menbers: _vm.menbers
                                                          },
                                                          on: {
                                                            chooseMenber:
                                                              _vm.chooseMenber,
                                                            delUser:
                                                              _vm.delUser,
                                                            delLeven:
                                                              _vm.delLeven,
                                                            addLeven:
                                                              _vm.addLeven
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.isGroup &&
                                !_vm.checkedBatch &&
                                _vm.hasApplyApproval === true
                                  ? _c(
                                      "div",
                                      { staticClass: "f-center2" },
                                      [
                                        _c("el-form-item", [
                                          _c(
                                            "h4",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                                "margin-right": "15px"
                                              },
                                              style: {
                                                display: _vm.isInDingTalk
                                                  ? "none"
                                                  : ""
                                              }
                                            },
                                            [
                                              _c("i"),
                                              _vm._v(
                                                "其他设置\n                      "
                                              )
                                            ]
                                          ),
                                          !_vm.isInDingTalk
                                            ? _c(
                                                "div",
                                                { staticClass: "bow" },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "100px"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "#000000"
                                                          },
                                                          attrs: {
                                                            slot: "label"
                                                          },
                                                          slot: "label"
                                                        },
                                                        [_vm._v("选择审批流程")]
                                                      ),
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            placeholder:
                                                              "请选择审批流程"
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChangeApprovalFlow
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.approvalFlowSelect,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.approvalFlowSelect = $$v
                                                            },
                                                            expression:
                                                              "approvalFlowSelect"
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.approvalFlowList,
                                                          function(v, index) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: index,
                                                                attrs: {
                                                                  value:
                                                                    v.flowId,
                                                                  label:
                                                                    v.flowName
                                                                }
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm.flows.length > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            border:
                                                              "1px solid rgba(229, 229, 229, 1)",
                                                            "border-radius":
                                                              "4px",
                                                            "margin-top": "12px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display:
                                                                  "inline-block",
                                                                position:
                                                                  "relative"
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.flows,
                                                              function(
                                                                v,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "flow",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      model: v,
                                                                      hiddenArrow:
                                                                        v.hiddenArrow,
                                                                      hiddenRemove: false
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        attrs: {
                                                                          slot:
                                                                            "username"
                                                                        },
                                                                        slot:
                                                                          "username"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle: {
                                                                              color:
                                                                                "#aaaaaa"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  v.partyName
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.isGroup && !_vm.checkedBatch
                                  ? _c(
                                      "div",
                                      { staticClass: "f-center2" },
                                      [
                                        _c(
                                          "el-form-item",
                                          { staticClass: "bow" },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "cc_title" },
                                              [_vm._v("文件抄送人")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  border:
                                                    "1px solid rgba(229, 229, 229, 1)",
                                                  "border-radius": "4px",
                                                  overflow: "hidden",
                                                  padding: "8px 0"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "audit-flex" },
                                                  [
                                                    _vm._l(
                                                      _vm.arrayCopior,
                                                      function(item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "audit-box"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "icon icon-audit-touxiang66"
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "auditor"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.userName ||
                                                                        item.partyName ||
                                                                        item.corpUserName
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: !item.hideRemove,
                                                                  expression:
                                                                    "!item.hideRemove"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "icon icon-audit-cuowu17 size17",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleClickRemoveArrayCopior(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "audit-add",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.clickHandleAddAuditorOrCopyer()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "icon icon-audit-add-2x"
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.isMine()
                                  ? _c(
                                      "div",
                                      { staticClass: "bow" },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "cc_title" },
                                              [_vm._v("选择签章")]
                                            ),
                                            [
                                              _vm.chapterList.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "temone-box"
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.chapterList,
                                                        function(item, index) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "temone-chap",
                                                                class: {
                                                                  "select-border": _vm.chapterCheck.includes(
                                                                    item.corpSealId
                                                                  )
                                                                    ? true
                                                                    : false
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.selectChap(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "select_img",
                                                                  attrs: {
                                                                    src:
                                                                      "/images/selected.png",
                                                                    alt: ""
                                                                  }
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info_box"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-popover",
                                                                      {
                                                                        attrs: {
                                                                          placement:
                                                                            "top-start",
                                                                          trigger:
                                                                            "hover"
                                                                        }
                                                                      },
                                                                      [
                                                                        (!_vm.isInDingTalk &&
                                                                          item.flowDetail) ||
                                                                        (_vm.isInDingTalk &&
                                                                          item.dingTalkFlow)
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle: {
                                                                                  padding:
                                                                                    "10px",
                                                                                  "font-weight":
                                                                                    "bold"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                    " +
                                                                                        _vm._s(
                                                                                          !_vm.isInDingTalk
                                                                                            ? item.flowDetail &&
                                                                                                item
                                                                                                  .flowDetail
                                                                                                  .flowName
                                                                                            : _vm.isInDingTalk &&
                                                                                              item.dingTalkFlow
                                                                                            ? item
                                                                                                .dingTalkFlow
                                                                                                .flowName
                                                                                            : ""
                                                                                        ) +
                                                                                        "\n                                  "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      height:
                                                                                        "125px",
                                                                                      overflow:
                                                                                        "auto"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "approval-process",
                                                                                      {
                                                                                        attrs: {
                                                                                          flowInfo: _vm.computeInfo(
                                                                                            _vm.isInDingTalk
                                                                                              ? item.dingTalkFlow
                                                                                              : item.flowDetail
                                                                                          ),
                                                                                          orderFlag: _vm.isInDingTalk
                                                                                            ? item
                                                                                                .dingTalkFlow
                                                                                                .flowType
                                                                                            : item
                                                                                                .flowDetail
                                                                                                .orderFlag
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      padding:
                                                                                        "20px",
                                                                                      color:
                                                                                        "#606266",
                                                                                      "font-weight":
                                                                                        "bold"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "无审批流程"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            attrs: {
                                                                              slot:
                                                                                "reference"
                                                                            },
                                                                            slot:
                                                                              "reference"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "t-box"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "y-img",
                                                                                    attrs: {
                                                                                      src:
                                                                                        item.signUrl,
                                                                                      title:
                                                                                        item.sealName
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                attrs: {
                                                                                  title:
                                                                                    "" +
                                                                                    item.sealName
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    "" +
                                                                                      item.sealName
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        color: "#ec1c1e"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "您还没有获得企业印章的使用授权，可继续发起合同，请在签署前联系管理员给您进行印章授权！"
                                                      )
                                                    ]
                                                  )
                                            ]
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm.collaborationType
                            ? _c(
                                "div",
                                {
                                  staticClass: "card",
                                  staticStyle: { "background-color": "#ffffff" }
                                },
                                [
                                  _c("div", { staticClass: "card-tit" }, [
                                    _vm._v(
                                      "\n                  协作人\n                "
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { padding: "10px" } },
                                    [
                                      _vm.darfPhoneList.length !== 0
                                        ? _c(
                                            "el-form",
                                            {
                                              ref: "dynamicValidateFormRef",
                                              staticStyle: {
                                                "margin-top": "10px"
                                              },
                                              attrs: {
                                                model: _vm.dynamicValidateForm,
                                                "label-width": "100px",
                                                size: "small"
                                              }
                                            },
                                            _vm._l(_vm.darfPhoneList, function(
                                              item,
                                              i
                                            ) {
                                              return _c(
                                                "el-form-item",
                                                {
                                                  key: item.i,
                                                  attrs: {
                                                    label:
                                                      "协作人" + (i + 1) + ":",
                                                    "label-width": "100px",
                                                    size: "small"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "item-sty" },
                                                    [
                                                      _c("el-input", {
                                                        style: {
                                                          "margin-right":
                                                            "10px",
                                                          width: _vm.inputWidth
                                                        },
                                                        attrs: {
                                                          value:
                                                            item.mobilePhone,
                                                          readonly: ""
                                                        }
                                                      }),
                                                      _c("el-input", {
                                                        style: {
                                                          width: _vm.inputWidth
                                                        },
                                                        attrs: {
                                                          value: item.userName,
                                                          readonly: ""
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-form",
                                        {
                                          ref: "dynamicValidateFormRef",
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: {
                                            model: _vm.dynamicValidateForm,
                                            "label-width": "100px",
                                            size: "small"
                                          }
                                        },
                                        _vm._l(
                                          _vm.dynamicValidateForm.domains,
                                          function(domain, index) {
                                            return _c(
                                              "el-form-item",
                                              {
                                                key: domain.key,
                                                attrs: {
                                                  label:
                                                    "协作人" +
                                                    (Number(
                                                      _vm.darfPhoneList.length
                                                    ) +
                                                      index +
                                                      1),
                                                  prop:
                                                    "domains." +
                                                    index +
                                                    ".mobile",
                                                  rules: domain.r_mobile
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "item-sty" },
                                                  [
                                                    _c("el-input", {
                                                      style: {
                                                        "margin-right": "10px",
                                                        width: _vm.inputWidth
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "协作人手机号"
                                                      },
                                                      model: {
                                                        value: domain.mobile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            domain,
                                                            "mobile",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "domain.mobile"
                                                      }
                                                    }),
                                                    _c("el-input", {
                                                      style: {
                                                        width: _vm.inputWidth
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "协作人名称"
                                                      },
                                                      model: {
                                                        value: domain.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            domain,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "domain.name"
                                                      }
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-circle-plus-outline",
                                                      staticStyle: {
                                                        margin: "0 10px"
                                                      },
                                                      on: {
                                                        click: _vm.addDomain
                                                      }
                                                    }),
                                                    _c("i", {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm
                                                              .dynamicValidateForm
                                                              .domains.length >
                                                            1,
                                                          expression:
                                                            "dynamicValidateForm.domains.length > 1"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "el-icon-delete",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeDomain(
                                                            domain
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "text-center",
                              style: {
                                "margin-top": "10px"
                              }
                            },
                            [
                              !_vm.collaborationType
                                ? [
                                    !_vm.$route.query.multiFileKey
                                      ? _c(
                                          "el-button",
                                          {
                                            class: {
                                              "g-save-disable":
                                                _vm.isSaveDisable
                                            },
                                            attrs: {
                                              disabled: _vm.isSaveDisable
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveAsDraft(true)
                                              }
                                            }
                                          },
                                          [_vm._v("存为草稿")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        ref: "signStep5",
                                        attrs: {
                                          id: "signStep5",
                                          type: "danger"
                                        },
                                        on: { click: _vm.handleTPL }
                                      },
                                      [_vm._v("下一步")]
                                    )
                                  ]
                                : _c(
                                    "el-button",
                                    {
                                      ref: "signStep5",
                                      attrs: {
                                        id: "signStep5",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.submitForm(
                                            "dynamicValidateFormRef"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("发起协同")]
                                  )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("ViewFilesToDoc", {
                    attrs: {
                      visibleShow: _vm.visibleShowEnclosureDoc,
                      enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
                    },
                    on: {
                      setViewFilesToDocDialogData:
                        _vm.onSetViewFilesToDocDialogData
                    }
                  }),
                  _c("ViewFilesToImg", {
                    attrs: {
                      visibleShow: _vm.visibleShowEnclosure,
                      isRefresh: _vm.isRefresh,
                      enclosurePreviewNumItem: _vm.enclosurePreviewNumItem,
                      imgList: _vm.getEnclosureImgList
                    },
                    on: {
                      setViewFilesToImgDialogData:
                        _vm.onSetViewFilesToImgDialogData
                    }
                  }),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: _vm.auditAndCopyTitle,
                        visible: _vm.visibleAuditAndCopy,
                        width: "50%"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.visibleAuditAndCopy = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { staticClass: "tel-search" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0 10px" },
                                      attrs: { span: 8 }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          size: "small",
                                          placeholder: "邮箱/手机号"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.clickHandleMyCorpSearch()
                                          }
                                        },
                                        model: {
                                          value: _vm.myCorpModel.keyword,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.myCorpModel,
                                              "keyword",
                                              $$v
                                            )
                                          },
                                          expression: "myCorpModel.keyword"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0 10px" },
                                      attrs: { span: 8 }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          size: "small",
                                          placeholder:
                                            _vm.auditAndCopyTitle ===
                                            "添加抄送人"
                                              ? "名称"
                                              : "签署方名称"
                                        },
                                        model: {
                                          value: _vm.myCorpModel.corpUserName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.myCorpModel,
                                              "corpUserName",
                                              $$v
                                            )
                                          },
                                          expression: "myCorpModel.corpUserName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0 10px" },
                                      attrs: { span: 8 }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "请选择部门",
                                            size: "small"
                                          },
                                          model: {
                                            value: _vm.myCorpModel.corpGroupId,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.myCorpModel,
                                                "corpGroupId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "myCorpModel.corpGroupId"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "全部", value: "" }
                                          }),
                                          _vm._l(_vm.department, function(
                                            item,
                                            i
                                          ) {
                                            return _c("el-option", {
                                              key: i,
                                              attrs: {
                                                label: item.groupName,
                                                value: item.corpGroupId
                                              }
                                            })
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3, offset: 1 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.queryToolMyCorp()
                                    }
                                  }
                                },
                                [_vm._v("查询")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "tel-box",
                          staticStyle: { height: "415px", overflow: "auto" }
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.myCorpModel.loading,
                                  expression: "myCorpModel.loading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                "row-key": "corpUserId",
                                "empty-text": _vm.myCorpModel.emptyText,
                                "reserve-selection": true,
                                data: _vm.tableListMyCorp,
                                "tooltip-effect": "dark",
                                "highlight-selection-row": "",
                                stripe: "",
                                "cell-style": { cursor: "pointer" },
                                "header-cell-style": {
                                  background: "#f9f9f9",
                                  color: "#333333",
                                  fontWeight: "500"
                                }
                              },
                              on: {
                                "row-click": _vm.handleRowClickAuditAndCopy,
                                "selection-change": _vm.handleSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "selection",
                                  "reserve-selection": true,
                                  width: "55"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "邮箱/手机号",
                                  prop: "targetId"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label:
                                    _vm.auditAndCopyTitle === "添加抄送人"
                                      ? "名称"
                                      : "签署方名称",
                                  prop: "userName"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "部门", prop: "groupNames" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c("el-pagination", {
                        staticStyle: { "text-align": "right" },
                        attrs: {
                          "current-page": _vm.myCorpModel.itemPage,
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.myCorpModel.pageSize,
                          layout: "sizes, prev, pager, next, jumper, total",
                          total: _vm.myCorpModel.total
                        },
                        on: {
                          "size-change": _vm.handleSizeChangeQueryToolMyCorp,
                          "current-change":
                            _vm.handleCurrentChangeQueryToolMyCorp
                        }
                      }),
                      _c(
                        "p",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  ;(_vm.tableAuditAndCopySelectRows = []),
                                    (_vm.visibleAuditAndCopy = false)
                                }
                              }
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "danger", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.clickHandleAddAuditorOrCopyerSubmit()
                                }
                              }
                            },
                            [_vm._v("添加")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "签署流程示意图",
                        visible: _vm.visibleSigningFlow,
                        width: "900px"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.visibleSigningFlow = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "signingFlow-box" }, [
                        _c("div", { staticClass: "signingFlow-tit" }, [
                          _c("img", {
                            staticClass: "photo",
                            attrs: {
                              src: _vm.currentUser.imgPath
                                ? _vm.fileOperShow(_vm.currentUser.imgPath)
                                : "/images/web/p-default.png"
                            }
                          }),
                          _c("p", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.currentUser.corpName ||
                                    _vm.currentUser.signatoryFullName ||
                                    _vm.currentUser.username
                                ) +
                                "\n                "
                            )
                          ])
                        ]),
                        _c("h4", [_vm._v("发起方")]),
                        _c("div", { staticClass: "arr-down" }, [
                          _c("i", { staticClass: "el-icon-arrow-down" })
                        ]),
                        _c(
                          "div",
                          { staticClass: "signingFlow" },
                          _vm._l(_vm.signatoryJson, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "signingFlow-item",
                                class: _vm.contractInfo.ifOrder ? "orderLi" : ""
                              },
                              [
                                item.hasOwnProperty("name")
                                  ? _c(
                                      "div",
                                      { staticClass: "signing-flow-tit" },
                                      [
                                        _c("img", {
                                          staticClass: "photo",
                                          attrs: {
                                            src: "/images/web/p-default.png"
                                          }
                                        }),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "light",
                                              placement: "bottom-end"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        证件号：" +
                                                    _vm._s(item.identityNo) +
                                                    "\n                        "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                        接收手机或邮箱：" +
                                                    _vm._s(item.account) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  item.name || "签署方名称"
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "signing-flow-tit" },
                                      [
                                        _c("img", {
                                          staticClass: "photo",
                                          attrs: {
                                            src: "/images/web/p-default.png"
                                          }
                                        }),
                                        _c("p", [_vm._v("批量签署方")])
                                      ]
                                    ),
                                _c("h4", [_vm._v("签署方")])
                              ]
                            )
                          }),
                          0
                        ),
                        _c("div", { staticClass: "arr-down" }, [
                          _c("i", { staticClass: "el-icon-arrow-down" })
                        ]),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.contractInfo.ifOrder
                                ? "顺序签署"
                                : "无顺序签署"
                            )
                          )
                        ])
                      ]),
                      _c(
                        "p",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  _vm.visibleSigningFlow = false
                                }
                              }
                            },
                            [_vm._v("确定")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-dialog",
                    {
                      staticClass: "prise-dialog",
                      attrs: {
                        visible: _vm.priseVisibleDialog,
                        title: "温馨提示",
                        "show-close": false,
                        width: "400px"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.priseVisibleDialog = $event
                        },
                        closed: _vm.handleDelSendContract
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "box-dashed text-center",
                          staticStyle: {
                            "margin-top": "10px",
                            "padding-bottom": "5px"
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: { height: "80px" },
                            attrs: { src: "/images/icon_signed.png" }
                          }),
                          _vm.priseInfo.mealInfo
                            ? [
                                _c("h4", [
                                  _vm._v(
                                    "\n                  本次共花费：\n                  "
                                  ),
                                  _c("span", { staticClass: "color-danger" }, [
                                    _vm._v(_vm._s(_vm.priseInfo.mealInfo))
                                  ])
                                ]),
                                _vm.priseInfo.point &&
                                !_vm.$route.query.multiFileKey
                                  ? _c("h4", [
                                      _vm._v(
                                        "\n                  另需要支付\n                  "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "color-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.priseInfo.point) + "积分"
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            : !_vm.$route.query.multiFileKey
                            ? _c(
                                "h4",
                                { staticStyle: { "font-weight": "bold" } },
                                [
                                  _vm._v(
                                    "\n                本次共花费：\n                "
                                  ),
                                  _c("span", { staticClass: "color-danger" }, [
                                    _vm._v(_vm._s(_vm.priseInfo.point) + "积分")
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "text-align": "start",
                                "margin-left": "8px"
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                "\n                发起后，签署方将收到签署短信/邮件通知，该通知" +
                                  _vm._s(_vm.dateTimeFn) +
                                  "小时有效，请尽快完成签署！\n              "
                              )
                            ]
                          )
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "text-center",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "footer-btn",
                              attrs: {
                                type: "danger",
                                size: "small",
                                disabled: _vm.payDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toPay(_vm.priseInfo.cashierUrl)
                                }
                              }
                            },
                            [_vm._v("确定")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "选择签署方",
                        visible: _vm.showTel,
                        "before-close": function() {
                          this$1.restCorp(), (this$1.showTel = false)
                        },
                        "lock-scroll": "",
                        width: "749px"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.showTel = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-tabs",
                        {
                          on: { "tab-click": _vm.tabClick },
                          model: {
                            value: _vm.activeTabSigner,
                            callback: function($$v) {
                              _vm.activeTabSigner = $$v
                            },
                            expression: "activeTabSigner"
                          }
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "常用签署方", name: "default" } },
                            [
                              _c(
                                "el-row",
                                {
                                  staticClass: "tel-search",
                                  attrs: { gutter: 10 }
                                },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          size: "small",
                                          placeholder: "接收手机号"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.getTelList()
                                          }
                                        },
                                        model: {
                                          value: _vm.telPageInfo.accountNo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.telPageInfo,
                                              "accountNo",
                                              $$v
                                            )
                                          },
                                          expression: "telPageInfo.accountNo"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          size: "small",
                                          placeholder: "签署方名称"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.getTelList()
                                          }
                                        },
                                        model: {
                                          value: _vm.telPageInfo.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.telPageInfo,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "telPageInfo.name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          size: "small",
                                          placeholder: "证件号"
                                        },
                                        nativeOn: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.getTelList()
                                          }
                                        },
                                        model: {
                                          value: _vm.telPageInfo.idNo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.telPageInfo,
                                              "idNo",
                                              $$v
                                            )
                                          },
                                          expression: "telPageInfo.idNo"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 2 } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "btn",
                                          attrs: { size: "small" },
                                          on: { click: _vm.getTelList }
                                        },
                                        [_vm._v("查询")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 2 } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "btn",
                                          attrs: { size: "small" },
                                          on: { click: _vm.reset }
                                        },
                                        [_vm._v("重置")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "tel-box",
                                  staticStyle: {
                                    "max-height": "340px",
                                    overflow: "auto",
                                    "min-width": "749px"
                                  }
                                },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.telList,
                                        "highlight-current-row": "",
                                        "tooltip-effect": "dark",
                                        stripe: "",
                                        "cell-style": { cursor: "pointer" },
                                        "header-cell-style": {
                                          background: "#f9f9f9",
                                          color: "#333333",
                                          fontWeight: "500"
                                        }
                                      },
                                      on: {
                                        "row-click":
                                          _vm.handleTelRowClickSelectRow
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "签署方名称",
                                          prop: "enterpriseName"
                                        }
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "证件号",
                                          prop: "businessLicense"
                                        }
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "接收手机号",
                                          prop: "mobileOrChild"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("el-pagination", {
                                staticStyle: {
                                  "text-align": "right",
                                  "margin-top": "10px"
                                },
                                attrs: {
                                  "current-page": _vm.telPageInfo.itemPage,
                                  "page-sizes": [10, 20, 50, 100],
                                  "page-size": _vm.telPageInfo.pageSize,
                                  layout:
                                    "sizes, prev, pager, next, jumper, total",
                                  total: _vm.telPageInfo.total
                                },
                                on: {
                                  "size-change": _vm.handleSizeChange,
                                  "current-change": _vm.handleCurrentChange
                                }
                              })
                            ],
                            1
                          ),
                          _vm._l(_vm.totalAccountListNews, function(
                            item,
                            index
                          ) {
                            return [
                              (item &&
                                item.userStemFrom !== -16 &&
                                !_vm.isInDingTalk) ||
                              (_vm.totalAccountListNews.length === 1 &&
                                !_vm.isInDingTalk) ||
                              _vm.isInDingTalk
                                ? [
                                    _c(
                                      "el-tab-pane",
                                      {
                                        key: index,
                                        attrs: {
                                          label: item.corpName,
                                          name: item.corpUserId + ""
                                        }
                                      },
                                      [
                                        _c(
                                          "el-row",
                                          { staticClass: "tel-search" },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 18 } },
                                              [
                                                _c(
                                                  "el-row",
                                                  [
                                                    _c(
                                                      "el-col",
                                                      {
                                                        staticStyle: {
                                                          padding: "0 10px"
                                                        },
                                                        attrs: { span: 8 }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            clearable: "",
                                                            size: "small",
                                                            placeholder:
                                                              "邮箱/手机号"
                                                          },
                                                          nativeOn: {
                                                            keyup: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                !$event.type.indexOf(
                                                                  "key"
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "enter",
                                                                  13,
                                                                  $event.key,
                                                                  "Enter"
                                                                )
                                                              ) {
                                                                return null
                                                              }
                                                              return _vm.clickHandleMyCorpSearch()
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.myCorpModel
                                                                .keyword,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.myCorpModel,
                                                                "keyword",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "myCorpModel.keyword"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      {
                                                        staticStyle: {
                                                          padding: "0 10px"
                                                        },
                                                        attrs: { span: 8 }
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            clearable: "",
                                                            size: "small",
                                                            placeholder:
                                                              "签署方名称"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.myCorpModel
                                                                .corpUserName,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.myCorpModel,
                                                                "corpUserName",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "myCorpModel.corpUserName"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      {
                                                        staticStyle: {
                                                          padding: "0 10px"
                                                        },
                                                        attrs: { span: 8 }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择部门",
                                                              size: "small"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.myCorpModel
                                                                  .corpGroupId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.myCorpModel,
                                                                  "corpGroupId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "myCorpModel.corpGroupId"
                                                            }
                                                          },
                                                          [
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "全部",
                                                                value: ""
                                                              }
                                                            }),
                                                            _vm._l(
                                                              _vm.department,
                                                              function(
                                                                item,
                                                                i
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: i,
                                                                    attrs: {
                                                                      label:
                                                                        item.groupName,
                                                                      value:
                                                                        item.corpGroupId
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 5, offset: 1 } },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "btn",
                                                    attrs: { size: "small" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.clickHandleMyCorpSearch()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("查询")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "btn",
                                                    attrs: { size: "small" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.restCorp(),
                                                          _vm.clickHandleMyCorpSearch()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("重置")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "tel-box",
                                            staticStyle: {
                                              height: "415px",
                                              overflow: "auto"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-table",
                                              {
                                                directives: [
                                                  {
                                                    name: "loading",
                                                    rawName: "v-loading",
                                                    value:
                                                      _vm.myCorpModel.loading,
                                                    expression:
                                                      "myCorpModel.loading"
                                                  }
                                                ],
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "empty-text":
                                                    _vm.myCorpModel.emptyText,
                                                  data: _vm.tableListMyCorp,
                                                  "highlight-current-row": "",
                                                  "tooltip-effect": "dark",
                                                  stripe: "",
                                                  "cell-style": {
                                                    cursor: "pointer"
                                                  },
                                                  "header-cell-style": {
                                                    background: "#f9f9f9",
                                                    color: "#333333",
                                                    fontWeight: "500"
                                                  }
                                                },
                                                on: {
                                                  "row-click":
                                                    _vm.handleRowClickMyCorp
                                                }
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "邮箱/手机号",
                                                    prop: "targetId"
                                                  }
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "签署方名称",
                                                    prop: "userName"
                                                  }
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "部门",
                                                    prop: "groupNames"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("br"),
                                        _c("el-pagination", {
                                          staticStyle: {
                                            "text-align": "right"
                                          },
                                          attrs: {
                                            "current-page":
                                              _vm.myCorpModel.itemPage,
                                            "page-sizes": [10, 20, 50, 100],
                                            "page-size":
                                              _vm.myCorpModel.pageSize,
                                            layout:
                                              "sizes, prev, pager, next, jumper, total",
                                            total: _vm.myCorpModel.total
                                          },
                                          on: {
                                            "size-change":
                                              _vm.handleSizeChangeQueryToolMyCorp,
                                            "current-change":
                                              _vm.handleCurrentChangeQueryToolMyCorp
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "danger", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.handleClickSelectSignorOk()
                                }
                              }
                            },
                            [_vm._v("确定")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("sign-info-tips-dialog", {
                    attrs: {
                      show: _vm.visibleCredit,
                      entCreditArr: _vm.entCreditArr,
                      entCreditJson: _vm.entCreditJson,
                      userIdentityInfoArr: _vm.userIdentityInfoArr
                    },
                    on: {
                      "update:show": function($event) {
                        _vm.visibleCredit = $event
                      },
                      continue: _vm.addContractById,
                      cancel: _vm.handleDelSendContract
                    }
                  })
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "添加水印",
                    width: "60%",
                    visible: _vm.setWatermarkVisible
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.setWatermarkVisible = $event
                    }
                  }
                },
                [
                  _c("waterMark", {
                    attrs: {
                      visible: _vm.setWatermarkVisible,
                      waterConfig: _vm.waterConfig
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.setWatermarkVisible = $event
                      },
                      "update:waterConfig": function($event) {
                        _vm.waterConfig = $event
                      },
                      "update:water-config": function($event) {
                        _vm.waterConfig = $event
                      }
                    }
                  })
                ],
                1
              ),
              _c("dialog-pup", {
                attrs: {
                  templateUpVisi: _vm.templateUpVisi,
                  fileList: _vm.fileList
                },
                on: {
                  "update:templateUpVisi": function($event) {
                    _vm.templateUpVisi = $event
                  },
                  "update:template-up-visi": function($event) {
                    _vm.templateUpVisi = $event
                  },
                  activeTplItem: _vm.activeTplItem,
                  officePDFInfo: _vm.officePDFInfo
                }
              }),
              _vm.setTempVariable
                ? _c("tpl-setting", {
                    attrs: {
                      fileList: _vm.fileList,
                      setTempVariable: _vm.setTempVariable
                    },
                    on: {
                      "update:setTempVariable": function($event) {
                        _vm.setTempVariable = $event
                      },
                      "update:set-temp-variable": function($event) {
                        _vm.setTempVariable = $event
                      },
                      replaceFiles: _vm.replaceFiles
                    }
                  })
                : _vm._e(),
              _c("more-setting", {
                attrs: {
                  signSetVisi: _vm.signSetVisi,
                  formInItem: _vm.formInItem,
                  activeTabsName: _vm.activeTabsName,
                  signatoryJson: _vm.signatoryJson
                },
                on: {
                  "update:signSetVisi": function($event) {
                    _vm.signSetVisi = $event
                  },
                  "update:sign-set-visi": function($event) {
                    _vm.signSetVisi = $event
                  },
                  "update:formInItem": function($event) {
                    _vm.formInItem = $event
                  },
                  "update:form-in-item": function($event) {
                    _vm.formInItem = $event
                  },
                  PupConfirm: _vm.PupConfirm,
                  videoPartIn: _vm.videoPartIn
                }
              }),
              _c("access-pup", {
                attrs: { signSetVisi: _vm.accessSetVisi },
                on: {
                  "update:signSetVisi": function($event) {
                    _vm.accessSetVisi = $event
                  },
                  "update:sign-set-visi": function($event) {
                    _vm.accessSetVisi = $event
                  },
                  PupConfirm: _vm.PupConfirm
                }
              }),
              _c("regular-pup", {
                attrs: {
                  regularVisi: _vm.regularVisi,
                  regularList: _vm.regularList
                },
                on: {
                  "update:regularVisi": function($event) {
                    _vm.regularVisi = $event
                  },
                  "update:regular-visi": function($event) {
                    _vm.regularVisi = $event
                  },
                  regularAdd: _vm.regularAdd
                }
              }),
              _c("editor-pup", {
                attrs: {
                  showofficeEditor: _vm.showofficeEditor,
                  editor: _vm.editor
                },
                on: {
                  "update:showofficeEditor": function($event) {
                    _vm.showofficeEditor = $event
                  },
                  "update:showoffice-editor": function($event) {
                    _vm.showofficeEditor = $event
                  },
                  saveLoading: _vm.saveLoading,
                  editedFile: _vm.editedFile
                }
              }),
              _c("cooper-pup", {
                attrs: { cooperVisi: _vm.cooperVisi },
                on: {
                  "update:cooperVisi": function($event) {
                    _vm.cooperVisi = $event
                  },
                  "update:cooper-visi": function($event) {
                    _vm.cooperVisi = $event
                  },
                  saveAndJump: _vm.saveAndJump
                }
              })
            ],
            1
          )
        ]
      ),
      _vm.cooperate
        ? _c(
            "div",
            [
              _c("to-create", {
                attrs: { cooperateInfo: _vm.cooperateInfo },
                on: { finishCooperate: _vm.finishCooperate }
              })
            ],
            1
          )
        : _vm._e(),
      _c("ReadPup", {
        attrs: { visi: _vm.readPupVisi },
        on: { PupConfirm: _vm.PupConfirm }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tooltip-text" }, [
      _c("span", [_vm._v("1")]),
      _vm._v(
        "拖动签署方至左侧预览内容中，指定该签署方在文件中签章的位置\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tooltip-text" }, [
      _c("span", [_vm._v("2")]),
      _vm._v(
        "表示该签署方在 “ 当前 ” 文件中设置的 “\n                    签章位置 ” 数量\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tooltip-text" }, [
      _c("span", [_vm._v("3")]),
      _vm._v(
        "表示该签署方在 “ 所有 ” 文件中设置的 “\n                    签章位置 ” 数量\n                  "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e52b0d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e52b0d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/collaborationEdit.vue
// module id = lQ4L
// module chunks = 3